export const ApplicationString = {
  //adminPanel
  'eventScheduleAdd.button.add': 'Add Schedule',
  'stemComponent.button.add': 'Add Stem',
  'eventTemplateScheduler.button.addForm': 'Add New Schedule',
  'CommitteeMemberComponent.button.addForm': 'Add Committee Member',
  'signup.button.register': 'Register',
  'common.button.clearFeeForm': 'Clear',
  'common.button.submitForm': 'Submit',
  'common.button.updateForm': 'Update',
  'common.button.backToEvents': 'Back To Events',
  'common.button.editAction': 'Edit',
  'common.button.deleteAction': 'Delete',
  'common.button.statusAction': 'Status',
  'adFeesComponent.button.addForm': 'Add New AdFee',
  'jobFeesComponent.button.addForm': 'Add New JobFee',
  'jobsComponent.button.addForm': 'Add New Job',
  'speakersComponent.button.addForm': 'Add New Speaker',
  'adsComponent.button.addForm': 'Add New Ad',
  'adsApprovedListComponent.button': 'Click here to place ads',
  'jobsApprovedListComponent.button': 'Click here to post jobs',
  'chaptersComponent.button.addForm': 'Add New Chapter',
  'emailCodesComponent.button.addForm': 'Add New Email Template',
  'keywordsComponent.button.addForm': 'Add New Interest',
  'eventTypesComponent.button.addForm': 'Add New Event Type',
  'companiesComponent.button.addForm': 'Add New Company',
  'couponCodesComponent.button.addForm': 'Add New Coupon Code',
  'sponsorsComponent.button.addForm': 'Add New Sponsor',
  'usersComponent.button.addForm': 'Add New member attendee',
  'usersComponent.updateWillReceiveModalTitle':
    'Update email update preference',
  'eventOptionGroupsComponent.button.addForm': 'Add New Event Option Group',
  'eventOptionsComponent.button.addForm': 'Add New Event Option',
  'eventsComponent.button.addForm': 'Add New Event',
  'pbssFilesComponent.button.addPbssFiles': 'Add New PBSS File',

  //Add Note Modal
  'addNoteModal.placeholder': 'Enter your note here...',
  'addNoteModal.description':
    'Please provide any additional information or comments about this event registration.',
  'addNoteModal.eventRegistrationId': 'Event Registration ID',
  'addNoteModal.addNote': 'Add Note',
  'addNoteModal.editNote': 'Edit Note',
  'addNoteModal.cancel': 'Cancel',
  //Special Payment
  'specialPayment.button.addForm': 'Generate Special Payment',
  'adminSpecialPayment.button.submit': 'Submit',
  'adminSpecialPayment.button.reset': 'Reset',
  'specialPayment.alertMessage': 'Thank you for your payment',
  'dynamicSearch.button.update': 'Update',
  'dynamicSearch.button.search': 'Search',
  'dynamicSearch.button.reset': 'Reset',
  'dynamicSearch.button.submit-your-feedback': 'Submit your feedback',
  'dynamicSearch.button.heading': 'Filter Search',
  'common.button.backForm': 'Cancel',
  'adminEvents.button.resetToLastSaved': 'Reset to last saved',
  'adminEvents.button.resetToLastSaved.tooltip':
    'Discards unsaved edits and restores the last saved event. You stay on this page.',
  'couponCodesFormComponent.button.addFormHeading': 'Add Coupon Code Details',
  'couponCodesFormComponent.button.editFormHeading': 'Edit Coupon Code Details',
  'speakersFormComponent.button.addFormHeading': 'Add Speakers Details',
  'speakersFormComponent.button.editFormHeading': 'Edit Speakers Details',
  'jobFeesFormComponent.button.addFormHeading': 'Add JobFees Details',
  'jobFeesFormComponent.button.editFormHeading': 'Edit JobFees Details',
  'adFeesFormComponent.button.addFormHeading': 'Add AdFees Details',
  'adFeesFormComponent.button.editFormHeading': 'Edit AdFees Details',
  'jobsFormComponent.button.addFormHeading': 'Add Jobs Details',
  'jobsFormComponent.button.editFormHeading': 'edit Jobs Details',
  'companiesFormComponent.button.addFormHeading': 'Add Companies Details',
  'companiesFormComponent.button.editFormHeading': 'edit Companies Details',
  'eventOptionGroupsFormComponent.button.addFormHeading':
    'Add EventOptionGroups Details',
  'eventOptionsFormComponent.button.editFormHeading':
    'edit EventOptionGroups Details',
  'eventOptionsFormComponent.button.addFormHeading': 'Add EventOptions Details',
  'eventOptionsFormComponent.button.editFormHeading':
    'edit EventOptions Details',
  //userPanel
  'userJobsComponent.cardHeading': 'PBSS.org Jobs Link Service',
  'userJobsComponent.cardSubHeading': 'vacancy Details from around the world',
  'userJobsComponent.contentHeading':
    'Our jobs link service posts jobs relevant to the pharmaceutical and bioscience industry. The jobs are also delivered to the 4000+ members through our newsletters.',
  'userComponent.button.addListing': 'Add New',
  'userComponent.button.addListing.approvedAds': 'Add New Ad',
  'userComponent.button.addListing.approvedJobs': 'Add New Job',
  'userAdsComponent.cardHeading': 'PBSS.org Ads Publish Service',
  'userAdsComponent.cardSubHeading': 'vacancy Details from around the world',
  'userResetPasswordComponent.heading': 'Reset Password',
  'userChangePasswordComponent.heading': 'Change Your Password',
  'userResetPasswordComponent.subheading':
    'No need to worry. Tell us your email and we will send you reset Password link to email address',
  'userChangePasswordComponent.subheading':
    'To enhance your account security, please enter your old password and choose a new one.',
  'userText.done': 'Done',
  'userText.cancel': 'Cancel',
  'userText.save': 'Save',
  'userText.welcomeToPbss': 'Welcome to Pbss',
  'userText.welcomeToPbssDescription':
    'working in diverse organizations such as the biotechnology and pharmaceutical industries.',
  'userText.LearnMore': 'Learn More',

  //About Us
  'userAboutUsComponent.heading': 'Pharmaceutical & BioScience Society',
  'userAboutUsComponent.paragraph':
    'Pharmaceutical & BioScience Society International is a non-profit professional organization of scientists and other professionals in the life science sector, working in diverse organizations such as the biotechnology and pharmaceutical industries, contract research organizations, life science tools suppliers, academia, and government laboratories. It has 20,000+ participants and is active through six member organizations in the San Francisco Bay Area, San Diego, Boston, Seattle, Vancouver, and Korea, some of the largest life science clusters in the World.',
  'userAboutUsComponent.ourMission': 'Our Mission',
  'userAboutUsComponent.chapterSanFranciscoBay':
    'About PBSS - San Francisco Bay',
  'userAboutUsComponent.chapterSanFranciscoBayAbout':
    'About San Francisco Bay Phrmaceutical & BioScience Society...',
  'userAboutUsComponent.ourMissionParagraph':
    'The mission of PBSS is to promote the exchange of scientific ideas and provide growth opportunities in the fields of pharmaceutical / life science related disciplines. We foster interactions and disseminate information through seminar luncheons, focused workshops (short courses), symposia, and webinars, as well as career development programs.',
  'userAboutUsComponent.standingCommittee': 'PBSS Leadership',
  'userAboutUsComponent.standingCommittee.subText':
    'Click on member name for their bio',
  'userAboutUsComponent.standingCommittee.boston':
    'Boston Chapter Committee Members',
  'userAboutUsComponent.standingCommittee.korea':
    ' Korea Chapter Committee Members',
  'userAboutUsComponent.standingCommittee.sf-bay':
    'San Francisco Bay Chapter Committee Members',
  'userAboutUsComponent.standingCommittee.san-diego':
    'San Diego Chapter Committee Members',
  'userAboutUsComponent.standingCommittee.vancouver':
    'Vancouver Chapter Committee Members',
  'userAboutUsComponent.standingCommittee.advisors': 'Distinguished Advisors',
  'userAboutUsComponent.standingCommittee.operationTeam': 'Operations Team',
  'userAboutUsComponent.standingCommittee.programManagement':
    'Program Management',
  'userAboutUsComponent.standingCommitteeParagraph':
    'Logo Represents the branding material of respective brand of vendor or corporate Sponsor.',
  'userCommonAdsListingCard.button.checkItOut': 'Check it out',
  //sponsor details
  'userAddAttendeeComponent.sponsorDetail.label':
    "Sponsor's Contact Information",
  'userAddAttendeeComponent.sponsorDetail.description':
    "Please fill out the Sponsor Details section before entering the attendee details. If the contact person is attending the meeting's presentations, please also fill out their information in the next section",
  'userAddAttendeeComponent.sponsorDetail.perksLabel':
    'Register for Workshop Attendees',
  'userAddAttendeeComponent.sponsorDetail.perksLabel': 'Vendor Show Attendance',
  'userAddAttendeeComponent.sponsorDetail.perksDescription':
    'Please note that Meeting Presentations registration includes Vendor Show registration but registrants for Vendor Show only do not have access to the meeting presentations',
  'userAddAttendeeComponent.sponsorDetail.perksDescription.major':
    'Major sponsor can have up to 2 free workshop seats. If you have more than two, additional fees must be paid.Please note that Meeting Presentations registration includes Vendor Show registration but registrants for Vendor Show only do not have access to the meeting presentations',
  // Add Attendee
  'userAddAttendeeComponent.regularAttendee.label': 'Attendees',
  'userAddAttendeeComponent.registerAs.sponsorText':
    'Click here for Sponsor Registration',
  'userAddAttendeeComponent.registerAs.myEvents': 'My Events',
  'userAddAttendeeComponent.regularAttendeeForSponsorAttendee.label':
    ' Regular Sponsor Attendee',
  'userAddAttendeeComponent.regularAttendeeForVendorAttendee.label':
    'Regular Vendor Attendee',
  'userAddAttendeeComponent.popup': `You can modify your registration up to 14 days before the event start date. Any changes within 14 days of the event require PBSS approval. Requests for modifications must be submitted to PBSS at `,
  'userAddAttendeeComponent.popup1': 'no later than 4 days before the event.',
  'userAddAttendeeComponent.message':
    'if you have a question or run into a problem with your registration.',

  // Ads Cart
  'userAdsCartComponent.heading': 'Ads',
  'userAdsCartComponent.subheading':
    'Get Details about event  price, schedule & more..',

  // Ads Form
  'userAdsFormComponent.heading': 'Vendor Advertisement Form',
  'userAdsFormComponent.subheading':
    ' Our advertisement posts relevant to the pharmaceutical and bioscience industry.The ads are also delivered to the 4000+ members through our newsletters.',

  // Approved Ads Listing
  'userApprovedAdsListingComponent.heading': 'PBSS - Approved Ads',
  'userApprovedAdsListingComponent.subheading':
    'Our advertisements are relevant to the pharmaceutical and bioscience industry. The ads are also delivered to the 4000+ members through our newsletters.',

  // My Ads
  'userAdsComponent.contentHeading':
    'You can submit text advertisements that are relevant to the pharmaceutical and bioscience industry. In addition to website display, these ads are also published in our twice-monthly email newsletters. The cost is $150/month and you can specify the duration of your ad in the ad submission process.',
  'userAdsComponent.heading': 'Advertisement Placement Service',
  'userAdsComponent.subheading': 'Publish your ads',

  // Assets Upload Component
  'userAssetsUploadComponent.uploadConditionText':
    '9x12 inch Letter size , Size Below 3MB PDF',
  'userAssetsUploadComponent.uploadLogoText': 'Upload logo',
  'userAssetsUploadComponent.1080px1080px': '1080px x 1080px',

  // Attendee Cart Component
  'userAttendeeCartComponent.button.goBacktoAddAttendeeText':
    'Go Back to Add Attendees',
  'userAttendeeCartComponent.confirm&PayText': 'Continue',
  'userAttendeeCartComponent.afterPayment': 'Edit Attendee',
  'userAttendeeCartComponent.subHeading': 'Review Cart & Confirm Details',
  'userAttendeeCartComponent.subHeading.afterPayment': 'Edit Attendee Details',
  'userAttendeeCartComponent.couponCodeTitle': 'Coupon code',
  'userAttendeeCartComponent.couponCodeButtonText': 'Redeem',
  'userAttendeeCartComponent.totalAmountToBePaid': 'Total amount to be paid',

  // Chapter Navigation Component
  'userChapterNavigationComponent.heading': 'Welcome to',
  'userChapterNavigationComponent.subheading':
    'Pharmaceutical & BioScience Society International',

  // Contact Us Component
  'userContactUsComponent.heading': 'Contact Us',
  'userContactUsComponent.ThankyouText':
    'We welcome and value your inquiries and feedback!',
  'userContactUsComponent.description': `As a grassroots organization, we thrive on ideas and contributions from our members. In fact, many of the topics and speakers for our meetings have come from members’ suggestions. If you have any suggestions, requests, or questions for PBSS, including potential future topics or your interest in organizing a meeting, please contact us using the following form. Alternately, you may also email us at info@pbss.org. `,
  'userContactUsComponent.captchaText': 'Complete CAPTCHA',
  'userContactUsComponent.button.welcomeVolunteers':
    'We always welcome volunteers!',
  // Contact Us Form Placeholder
  'userContactUsFormComponent.name.validationMessage':
    'Please fill out your name',
  'userContactUsFormComponent.state.placeholder': 'Enter state/province',
  'userContactUsFormComponent.email.validationMessage':
    'Please fill out your email',
  'userContactUsFormComponent.emailConfirm.validationMessage':
    'Please fill out your email',
  'userContactUsFormComponent.inquiry.validationMessage':
    'Please fill out your inquiry title',
  'userContactUsFormComponent.description.validationMessage':
    'Please fill out your details',
  'userContactUsFormComponent.captcha.validationMessage':
    'Please click on the CAPTCHA above',

  'userContactUsFormComponent.name.placeholder': 'Enter full name',
  'userContactUsFormComponent.email.placeholder': 'Enter email',
  'userContactUsFormComponent.emailConfirm.placeholder': 'Confirm email',
  'userContactUsFormComponent.inquiry.placeholder':
    'Enter topics or title of your inquiry',
  'userContactUsFormComponent.selectCity.placeholder': 'Enter city',
  'userContactUsFormComponent.selectCountry.placeholder': 'Enter country',
  'userContactUsFormComponent.phoneNumber.placeholder': 'Enter phone number',
  'userContactUsFormComponent.selectAffiliation.placeholder':
    'Select affiliation',
  'userContactUsFormComponent.selectEmailSubject.placeholder':
    'Select Email Subject',
  'userContactUsFormComponent.description.placeholder':
    'Add comments or description of matter',

  // Event Sponsor Component
  'userEventSponsorComponent.subheading':
    'Select option for sponsorship Registration',
  'userEventSponsorComponent.registerAs.regularAttendeeText':
    'Register as an Attendee',
  'userEventSponsorComponent.registerAs.myEvents': 'My Events',
  'userEventSponsorComponent.deleteText': 'attendee',
  'userEventSponsorComponent.backtoSponsorOption':
    'Go Back to Sponsorship Options',
  'userEventSponsorComponent.ProceedToPay': 'Continue',

  //test heading
  'testHeading.heading':
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam. Maecenas ligula massa, varius a, semper congue, euismod non, mi. Proin porttitor, orci nec nonummy molestie, enim est eleifend mi, non fermentum diam nisl sit amet erat. Duis semper. Duis arcu massa, scelerisque vitae, consequat in, pretium a, enim. Pellentesque congue. Ut in risus volutpat libero pharetra tempor.',

  //test heading
  'testHeading.heading':
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam. Maecenas ligula massa, varius a, semper congue, euismod non, mi. Proin porttitor, orci nec nonummy molestie, enim est eleifend mi, non fermentum diam nisl sit amet erat. Duis semper. Duis arcu massa, scelerisque vitae, consequat in, pretium a, enim. Pellentesque congue. Ut in risus volutpat libero pharetra tempor.',

  // Event Sponsor Cart
  'userEventSponsorCartComponent.backToSponsorship': 'Back to Sponsorship',
  'paymentCheckoutComponent.backToAddVendorReps': 'Back to Add Vendor Reps',

  // Event Details modal
  'userEventDetailsModal.alertMsg.expired':
    'The deadline for refunds for this event has passed. Please contact the administrator for further assistance.',

  // Approved Jobs
  'userApprovedJobsListingComponent.heading':
    'Life Science Jobs Submitted by Employers',
  'userApprovedJobsListingComponent.subtitle':
    'Work in diverse organizations across the biotechnology and pharmaceutical industries',
  'userApprovedJobsListingComponent.subheading':
    'The jobs listings are also delivered to our members through our newsletters.',
  'userApprovedJobsListingComponent.button.viewDetails': 'View Details',
  'userApprovedJobsListingComponent.button.edit': 'Edit Job',
  'userApprovedJobsListingComponent.button.delete': 'Delete Job',
  'stemOutreachComponent.title': 'STEM Outreach',
  'industryOutreachComponent.title': 'Industry News',
  'userApprovedJobsListingComponent.button.pay': 'Pay',
  // Jobs
  'userJobsComponent.button.viewMore': 'View More Jobs',
  'userJobsComponent.button.viewMoreJobs': 'View More Jobs',
  'userJobsComponent.searchForJobsText': 'Search for jobs',
  'userJobsComponent.locationText': 'Locations',
  'userJobsComponent.statusPlaceHolder': 'Status',
  'userJobsComponent.heading': 'Add New Job Listing',
  'userJobsComponent.subheading.part1': `Our job posting service shares opportunities in the pharmaceutical and bioscience industries. In addition to website display,`,
  'userJobsComponent.subheading.part2':
    ' these ads are also published in our twice-monthly email newsletters.',
  'userJobsComponent.uploadLogoText': 'Upload Logo',
  'userJobsComponent.paymentText':
    'First, complete the payment to proceed with the listing process.',
  'userJobsComponent.submit&CheckoutText': 'Proceed & Confirm',

  // Jobs View Details Component
  'userJobViewDetailsComponent.heading': 'Job Details',
  'userJobViewDetailsComponent.subheading':
    'vacancy details from around the world',
  'userJobViewDetailsComponent.button.applyNow': 'Apply Now',
  'userJobViewDetailsComponent.qualify&skillReq':
    'Qualifications & Skills Required',
  'userJobViewDetailsComponent.jobDescriptionText': 'Description :',
  'userJobViewDetailsComponent.jobPositionText': 'Position :',
  'userJobViewDetailsComponent.newHeading': 'Job Postings',

  //spnsor perks
  'userEventSponsorComponent.sponsorPerks.uploadLogo':
    'Upload Company/Sponsor Logo',
  'userEventSponsorComponent.sponsorPerks.editUploadLogo':
    'Upload Company/Sponsor Logo',
  'userEventSponsorComponent.sponsorPerks.eventSponsorButton': 'Register',
  'userEventSponsorComponent.sponsorPerks.addWaitingListButton':
    'Join Waiting List',
  'userEventSponsorComponent.sponsorPerks.eventContinueSponsorButton':
    'Continue Registration',
  'userEventSponsorComponent.sponsorPerks.removeFromCart': 'Remove From Cart',

  // UserJobsComponent
  'userJobsComponentPage.heading': 'Job Postings',
  'userJobsComponentPage.subheading': 'vacancy Details from around the world',

  // Login
  'userLoginComponent.heading': 'Login',
  'userLoginComponent.subheading':
    'Please log into your account | Login is required for event registration',
  // Reset Password
  'userResetPasswordComponent.heading': 'Reset Password',
  'userResetPasswordComponent.subheading':
    'Please update your password | Login required to register an event',
  'userLoginComponent.popup.heading': 'Terms & Conditions',
  'userLoginComponent.popup.subheading':
    'By continuing, you agree to our Terms of Service and the Japan Chapter Event Terms.',
  'userLoginComponent.validationTermsandConditions':
    'Terms and Conditions must be accepted.',
  'userLoginComponent.popup.button.viewTerms&Conditions':
    'View Terms & Conditions',
  'userLoginComponent.popup.button.accept': 'Accept',
  'userLoginComponent.popup.button.accepting': 'Accepting...',
  'userLoginComponent.addNote':
    "In order to avoid login issues due to job changes, we strongly encourage you to change your account's email address to a permanent personal email address if not already, after login. Please contact info@pbss.org to change your account email address.",

  // My Events
  'userMyEventsComponent.heading': 'PBSS - My Events',
  'userMyEventsComponent.subheading':
    'Please review the status of upcoming events that you have signed up for.',
  'userMyEventsComponent.button.registerForNewEvents':
    'Register for New Events',
  'userMyEventsComponent.cancellationPolicy': 'Cancellation Policy',
  'userMyEventsComponent.cancellationPolicy.title1': 'Meetings Attendees:',
  'userMyEventsComponent.cancellationPolicy.content1':
    'All refund requests made by attendees must be received through the website at least three working days before the event begins. All refund transactions will be made in full, less any credit card processing fee. After the refund deadline, the registration payment becomes non-refundable.',

  'userMyEventsComponent.cancellationPolicy.title2': 'Major Sponsorships:',
  'userMyEventsComponent.cancellationPolicy.content2':
    'Payments are refundable minus a $500 penalty up to 2 months prior to the date of the sponsored event. After the refund deadline, the sponsorship payment becomes non-refundable.',

  'userMyEventsComponent.cancellationPolicy.title3': 'Lunch Sponsorships:',
  'userMyEventsComponent.cancellationPolicy.content3':
    'Payments are refundable minus a $300 penalty up to 2 months prior to the date of the sponsored event. After the refund deadline, the sponsorship payment becomes non-refundable.',

  'userMyEventsComponent.cancellationPolicy.title4': 'Happy Hour Sponsorships:',
  'userMyEventsComponent.cancellationPolicy.content4':
    'Payments are refundable minus a $300 penalty up to 2 months prior to the date of the sponsored event. After the refund deadline, the sponsorship payment becomes non-refundable.',

  'userMyEventsComponent.cancellationPolicy.title5': 'Vendor Shows:',
  'userMyEventsComponent.cancellationPolicy.content5':
    'Payments are refundable minus a $100 penalty up to 2 weeks prior to the date of the sponsored event. After the refund deadline, the sponsorship payment becomes non-refundable.',
  'userMyEventsComponent.cancellationPolicy.content6':
    'Credit card transaction fees will be deducted from any refund requests, regardless of when they are made. All refund requests must be made online at the My Events page after you log into your account. We hope that you can understand this policy, since we are a volunteer-run organization and have to minimize the effort our volunteers spend on dealing with such issues. Please note that the policy may vary depending on the chapter. Please contact <a href="mailto:info@pbss.org">info@pbss.org</a> for questions.',

  // My Events CART
  'userMyEventsCartComponent.heading': 'PBSS - My Cart',
  'userMyEventsCartComponent.subheading':
    ' Checkout status of upcoming to be paid events that you have signed up for.',
  'userMyEventsCartComponent.totalAmount': 'Total amount to be paid',
  'userMyEventsCartComponent.paymentHint':
    'Complete payment for each event below. Click "Complete Payment" on an event to proceed to checkout.',

  // PBSS Chapter Component
  'userPbssChapterComponent.heading':
    'Welcome to the Pharmaceutical & BioScience Society',

  // Workshop Agenda
  'userWorkShopAgendaComponent.heading.Bio': 'Event Description',
  'userWorkShopAgendaComponent.heading.Info': 'Event Agenda',
  'userWorkShopAgendaComponent.heading.Speaker': "Speakers' Bios",
  'userWorkShopAgendaComponent.subheading':
    'Clinical pharmacology is an integral component of drug development that plays a vital role in establishing the right target, right dose, and right population throughout the development and the life cycle management of an investigational product. ',

  // Event Form Admin Leave Popup
  'userEventFormAdminLeavePopupComponent.heading':
    'Do you want to leave the page?',
  'userEventFormAdminLeavePopupComponent.subheading':
    'The changes you made will be lost. Click on the Continue Editing button to stay on the same page, else click on Exit to leave the page',
  'userEventFormAdminLeavePopupComponent.button.continueEditing':
    'Continue Editing',
  'userEventFormAdminLeavePopupComponent.button.exit': 'Exit',
  //STEM Highlights
  'userStemHighlightsComponent.mainTitleText': 'STEM Highlights',
  // Industry Highlights
  'userIndustryHighlightsComponent.mainTitleText': 'Industry Highlights',
  //CAREER Mentorship Highlights
  'userCareerMentorshipHighlightsComponent.mainTitleText':
    'Career Mentorship Highlights',
  // Event Info Card
  'userEventInfoCardComponent.mainTitleText': 'Event Highlights',
  'userEventInfoCardComponent.props.date': 'Sept 12 | Tuesday',
  'userEventInfoCardComponent.props.eventName':
    'Clinical Pharmacology Event | 2023',
  'userEventInfoCardComponent.props.description':
    'Clinical pharmacology is an integral component of drug development...',
  'userEventInfoCardComponent.props.location': 'Conference at SF- Bay',

  'userEventInfoCardComponent.card.title-image1':
    ' Clinical Pharmacology Across the Drug Development Continuum | 2022',
  'userEventInfoCardComponent.card.date-image1': 'Sept 06 | Tuesday',
  'userEventInfoCardComponent.card.description-image1':
    'Clinical pharmacology is an integral component of drug development that plays a vital role in establishing the right target, right dose, and right population throughout the development and the life cycle management of an investigational product. This workshop will provide an overview of how clinical pharmacology contributes to key decision‑making milestones throughout the drug development process, from establishing a first-in-human dose to crafting the package insert for filing. The fundamental principles and strategy for conducting clinical pharmacology studies as well as modeling and simulation approaches to accelerate the drug development process will be covered. Real-world applications will illustrate contemporary approaches to developing and executing a clinical pharmacology program. This workshop is suitable for novice drug developers, experts from other disciplines interested in learning more about the field, and clinical pharmacologists looking to refresh their knowledge and discuss emerging topics.',
  'userEventInfoCardComponent.card.location-image1': 'Conference at San-Diego',

  'userEventInfoCardComponent.card.title-image2':
    'Taking the leap: Everything you want to know about starting a Biotech | 2023',
  'userEventInfoCardComponent.card.date-image2': 'May 25 | Thursday',
  'userEventInfoCardComponent.card.description-image2':
    'Have you ever wondered what it takes to start a biotech?  Are you planning your next career move to a small startup or stealth company and want to understand the benefits/risks?  Or are you curious to get into the mind of a passionate entrepreneur?  Join us for an interactive hour long “nourishing greatness” session where you can learn more about this fascinating topic and hear from accomplished experts.  ',
  'userEventInfoCardComponent.card.location-image2': 'Conference at Korea',

  'userEventInfoCardComponent.card.title-image3':
    'Oncology Clinical Dose Optimization in Light of FDA Project Optimus | 2024',
  'userEventInfoCardComponent.card.date-image3': 'Feb 12 | Monday',
  'userEventInfoCardComponent.card.description-image3':
    'Historically, dose selection in oncology was driven by the MTD paradigm. This traditional approach was partly driven by the few available therapies in oncology, and the need to bring effective drugs to the market as soon as possible. Now that the field of oncology drug development has matured and cancer patients are living longer than ever on chronic therapies, we as drug developers need to meet these new challenges by shifting our approach to oncology dose selection to a new paradigm. This one-day symposium will discuss the new regulatory expectations to oncology dose selection, various approaches to optimize oncology dose selection from a study design as well as statistical perspective, different clinical pharmacology considerations and related analysis to support dose selection, and evaluations using patient-reported outcomes.',
  'userEventInfoCardComponent.card.location-image3':
    'Conference at  PBSS SF-Bay',

  // Register
  'userRegisterComponent.heading': 'Join PBSS',
  'userRegisterComponent.subheading':
    'Pharmaceutical & BioScience Society International',
  'userRegisterComponent.description':
    'To join PBSS, please fill out the form below',
  'userRegisterComponent.disclaimer':
    'To protect the privacy of our members, membership information is strictly used for PBSS operations only, and is not shared outside of PBSS.',
  'userRegisterComponent.disclaimer2':
    'By becoming a member of PBSS, you are automatically subscribed to receive our newsletter via email. If you wish to unsubscribe, you can do so at any time.',

  // Sponsor Policy
  'userSponsorPolicyComponent.p1':
    'At least 1 day before the event, you MUST email your slides to the organizer. Keep in mind that your slot has only 10 minutes and you need to plan accordingly.',
  'userSponsorPolicyComponent.p2':
    'Complimentary lunch is provided to two representatives of the major sponsor during a workshop / symposium. If it is a seminar luncheon, the number of lunch is unlimited. Online registration is require',
  'userSponsorPolicyComponent.membershipListSharing':
    'Policy on Membership List Sharing:',
  'userSponsorPolicyComponent.membershipListSharing.description':
    'In order to protect the privacy of our members, our membership information, such as membership list and meeting attendees list, is strictly used for our internal business only and can not be shared with any party externally.',
  'userSponsorPolicyComponent.vendorShowCard.title':
    'Policy on Vendor Speakers for "Non-commercial" Presentations:',
  'userSponsorPolicyComponent.vendorShowCard.description': `We often receive requests from vendors for providing a speaker for one of our scientific meetings. Unfortunately, in order to avoid any impression of commercial promotion or vendor favoritism, our policy generally prohibits use of vendor speakers, except in rare cases where a vendor holds a unique technology that we are interested in hearing about. One compromise solution is that the vendor can recommend a client scientist who is an expert on the vendor's technology.`,
  'userSponsorPolicyComponent.vendorShowCard.title2':
    'Policies on Vendor Reps attending the vendor show and workshop:',
  'userSponsorPolicyComponent.vendorShowCard.li1': `Each vendor show sponsor can send unlimited number of reps for attending the booth (but not for attending the workshop). If the additional reps needs lunch, the lunch can be purchased online in several ways: 1) the rep who is registering for the vendor show can add more reps either at the point of paying for the vendor show or at a later point by re-logging in; 2) the additional rep can log in on his/her own to purchase the lunch..`,
  'userSponsorPolicyComponent.vendorShowCard.li2': `One rep per vendor can register for the workshop at just the cost of the handout when registering for the vendor show.`,
  'userSponsorPolicyComponent.vendorShowCard.li3': `If an additional rep / employee wants to attend the workshop, he/she needs to register as a regular attendee (workshop attendance + handout +/- lunch). If this rep does not want to pay for the workshop, he/she may sit in without registration, space permitting. However, that rep will not be able to purchase just a copy of the handout separately online or on-site. He/she can register on-site at the regular online workshop rate (workshop attendance + handout +/- lunch), as opposed to the much higher on-site rate for the regular walk-in attendees..`,
  'userSponsorPolicyComponent.vendorShowCard.li4': `The Major Sponsor gets 2 free workshop seats + 2 copies of handout + 2 lunches; No separate registration other than the Major Sponsorship payment is required.`,
  'userSponsorPolicyPage.title': 'Sponsorship Policy',
  'userSponsorPolicyPage.subtitle':
    'Information here for our sponsorship Policies',

  // Event Major Sponsor page
  'userEventMajorSponsorPage.heading': 'Major Sponsorship',
  'userEventMajorSponsorPage.subheading':
    'You can become a sponsor by clicking on the ‘Register as a Sponsor’ button from the event details.',
  'userEventMajorSponsorPage.description':
    'For a seminar luncheon or a half-day session of a full-day event, we allow only one Major Sponsorship slot.',
  'userEventMajorSponsorCard.heading': 'Major Sponsorship',
  'userEventMajorSponsorCard.regularPriceText': 'Regular Price',
  'userEventMajorSponsorCard.benefitsText': 'Benefits:',
  'userEventMajorSponsorCard.bodyText': `As the sole Major Sponsor of an event or session, you will get great exposure through:`,
  'userEventMajorSponsorCard.li1': `Distributing your product brochures to the attendee's seats`,
  'userEventMajorSponsorCard.li2': `A 10-minute podium presentation opportunity immediately before the
  keynote seminar`,
  'userEventMajorSponsorCard.li3': `A 6 display table at the most prominent location`,
  'userEventMajorSponsorCard.afterListText':
    ' All sponsorship payments MUST be made through our website. We do not issue purchasing orders.',
  'userEventMajorSponsorCard.buttonText.signupforsponsorship':
    'Register for Sponsorship',
  'userEventMajorSponsorCard.buttonText.contactourvendorliaison':
    'Contact Our Vendor Liaison',
  'userEventMajorSponsorCard.buttonText.makeaspecialpayment':
    'Make a Special Payment',
  'userEventMajorSponsorCard.instructions.heading':
    'Major Sponsorship Instructions:',
  'userEventMajorSponsorCard.instructions.l1':
    'At least 1 day before the event, you MUST email your slides to the organizer. Keep in mind that your slot has only 10 minutes and you need to plan accordingly.',
  'userEventMajorSponsorCard.instructions.l2':
    'Complimentary lunch is provided to two representatives of the major sponsor during a workshop/symposium. If it is a seminar luncheon, the number of lunches is unlimited. Online registration is required.',

  // Sponsorship option
  'userSponsorshipOptionComponent.heading': 'Select Sponsorship Type',
  'userSponsorshipOptionComponent.subheading': '',
  'userSponsorshipOption.alertMessage':
    'There are no sponsorships slots available for this event! Please navigate back to the Attendee Registration page to register as a regular attendee.',
  'userNormalAttendee.alertMessage':
    ' The sponsorship registrations are now open, click on the above button to proceed. The slots for regular registrations will open soon, keep an eye on this page!',
  'userRegistrationOption.alertMessage':
    'The sponsorship registrations are now open, click on the above button to proceed.The slots for regular registrations will open soon, keep an eye on this page!',

  // Vendor Show
  'userVendorShowComponent.heading': 'Vendor Sponsorship',
  'userVendorShowComponent.subheading':
    'You can become a sponsor by clicking on the ‘Register as a Sponsor’ button from the event details',

  // Vendor Info Card
  'userVendorInfoCardComponent.p1':
    'At least 1 day before the event, you MUST email your slides to the organizer. Keep in mind that your slot has only 10 minutes and you need to plan accordingly.',
  'userVendorInfoCardComponent.p2':
    'Complimentary lunch is provided to two representatives of the major sponsor during a workshop / symposium. If it is a seminar luncheon, the number of lunch is unlimited. Online registration is require',
  'userVendorInfoCardComponent.title':
    'Lunch Option for Vendor Show Representatives:',
  'userVendorInfoCardComponent.body1.label': 'Seminar luncheon vendor show:',
  'userVendorInfoCardComponent.body1.p':
    'lunches are complimentary , but online registration is required.',
  'userVendorInfoCardComponent.body2.label': 'Workshop / symposium vendor show',
  'userVendorInfoCardComponent.body2.p':
    'lunches can be purchased during the online registration process.',
  'userVendorInfoCardComponent.vendorShowCard1.title':
    'Attending a Vendor Show:',
  'userVendorInfoCardComponent.vendorShowCard1.li1':
    'Each vendor will get a 6 display table. You can display anything appropriate on the table , as well as a poster on the wall behind the table using painters tape',
  'userVendorInfoCardComponent.vendorShowCard1.li2':
    'The Table next to the meeting room entrance is reserved for the Major Sponsor.',
  'userVendorInfoCardComponent.vendorShowCard1.li3':
    'For seminar luncheons and afternoon workshops, arrive by 11:00 AM to set up . For full-day workshops, arrive by 8:00am to set up.',
  'userVendorInfoCardComponent.vendorShowCard1.li4': `You are encouraged to bring a raffle prize to attract attendees
  (we limit one prize per vendor). If it is a seminar luncheon, the
  raffle drawing takes place at the end of the seminar, 1:15 PM | If
  it is a workshop, the drawing takes place normally right before
  the final workshop session, ~4 PM.`,
  'userVendorInfoCardComponent.vendorShowCard2.title': 'Vendor show time',
  'userVendorInfoCardComponent.vendorShowCard2.time-p1':
    'Seminar luncheon vendor shows:',
  'userVendorInfoCardComponent.vendorShowCard2.time-label1':
    '11:00 AM - 12:45 PM',
  'userVendorInfoCardComponent.vendorShowCard2.time-p2':
    'Afternoon workshop vendor shows:',
  'userVendorInfoCardComponent.vendorShowCard2.time-label2':
    '11:00 AM - 12:15 PM',
  'userVendorInfoCardComponent.vendorShowCard2.time-p3':
    'Morning vendor shows:',
  'userVendorInfoCardComponent.vendorShowCard2.time-label3':
    '8:00 - 8:45 AM, 10:30 - 10:45 AM',
  'userVendorInfoCardComponent.vendorShowbtext1-p':
    'Indicate your name, company name, our organization name and meeting date before the workshop',
  'userVendorInfoCardComponent.vendorShowbtext1-label':
    'During the workshop breaks (typically ~2:30 - 2:45, ~3:45 - 4:00 PM).',
  'userVendorInfoCardComponent.vendorShowbtext2-span':
    'If you plan to ship your vendor show display materials to the meeting in advance:',
  'userVendorInfoCardComponent.vendorShowbtext2-p':
    'You can ship to the Banquet Office of the meeting venue hotel (Indicate your name, company name, our organization name and meeting date.).',
  //payment history
  'userPaymentHistoryComponent.subheading':
    'Checkout all Transection &  Refund Details from here',
  'userPaymentHistoryComponent.heading': 'Payment History',

  // Special Payment
  'specialPaymentFormComponent.button.proceedToPayment': 'Proceed to Payment',
  'specialPaymentFormComponent.returnButton.returnToNormalForm': 'Back',

  // Seminar Luncheons
  'userSeminarLuncheonsComponent.heading': 'Seminar Luncheons',
  'userSeminarLuncheonsComponent.p1':
    'Our seminar luncheons (typically free) are for networking and learning about selected advances in drug discovery and development.',
  'userSeminarLuncheonsComponent.p2':
    'Vendor shows during seminar luncheons allow attendees to interact with vendors and win raffle prizes. Be sure to bring your business cards to enter the raffles!',
  'userSeminarLuncheonsComponent.p3':
    'For information on upcoming seminar luncheons,',

  // Workshops
  'userWorkshopsComponent.heading': 'Workshops',
  'userWorkshopsComponent.p1':
    'Our workshops cover foundational topics in drug discovery and development, at minimal cost for participants (for example, registration fees for academic attendees and those who pay out of pocket are heavily subsidized). Each workshop is essentially a short course covering fundamentals, advances, applications, and case studies for a given topic. The speakers present a well coordinated curriculum, much like teaching different chapters of textbook. Workshops are typically full-day events. Course materials (PDF slides) are provided to attendees as a handy reference.',
  'userWorkshopsComponent.p2':
    'Workshops are typically held in person, but may be held virtually via Zoom. In-person workshops may also be webcast for attendees who are not local to the event.',
  'userWorkshopsComponent.p3': 'For information on upcoming workshops,',

  // Symposia
  'userSymposiaComponent.heading': 'Symposia',
  'userSymposiaComponent.p1':
    'Our symposia are like a conference session, with individual seminars covering the latest advances in an area of drug discovery and development. They are either held in-person or virtually via Zoom. The in-person symposia may also be webcast to attendees who are not local.',
  'userSymposiaComponent.p2':
    'Each symposium is a half-day (afternoon) or a full day.',
  'userSymposiaComponent.p2': 'For information on the upcoming symposia,',

  //Webinar
  'userWebinarsComponent.heading': 'Webinars',
  'userWebinarsComponent.p1':
    'Webinars typically involve one or two online presentations on a given topic and typically last 1-2 hours. ',
  'userWebinarsComponent.p2': `For information on the upcoming webinars,`,

  // Dinner Seminar
  'userDinnerSeminarComponent.heading': 'Dinner Seminars',
  'userDinnerSeminarComponent.p1':
    'Our dinner seminars are held on a less frequent basis and may include several seminars with related topics. Vendor shows are also held during the dinner seminars.',
  'userDinnerSeminarComponent.p2':
    'For information on the upcoming dinner seminars,',

  //Validation
  //only Alphabet Allow-
  'common.validation.onlyAlphabet': `#{name} only allows non-numeric characters and it should be less than #{maxLength} characters!`,

  // Sponsorship Info
  // Vendor Show Exhibition
  'userSponsorshipInfo.heading': '#{text} Sponsorship Info',
  'userSponsorshipInfo.content.vendorShow.h1': 'Vendor Show Exhibition:',
  'userSponsorshipInfo.content.p1':
    'Participation in an in-person PBSS event as #{text}.',
  'userSponsorshipInfo.content.p2': 'Your registration fee includes:',
  'userSponsorshipInfo.content.vendorShow.li1':
    'Vendor show tabletop space where you may display your company materials through the event.',
  'userSponsorshipInfo.content.vendorShow.li2':
    '2 attendees for the workshop at a subsidized price.',
  'userSponsorshipInfo.content.vendorShow.li3':
    'PDF Slide Deck of the presentations if the event is a workshop.',
  'userSponsorshipInfo.content.vendorShow.li4':
    'Participation in a Raffle (you collect business cards from our attendees and participate in a drawing along with other vendors to giveaway any prize of your choice to the attendee).',
  'userSponsorshipInfo.content.contactUs': 'For further details please contact',
  // Happy Hour Sponsorship
  'userSponsorshipInfo.content.happyHour.h1': 'Happy Hour Sponsorship:',
  'userSponsorshipInfo.content.happyHour.li1':
    'Vendor show tabletop space where you may display your company materials through the event.',
  'userSponsorshipInfo.content.happyHour.li2':
    'PDF Slide Deck of the presentations if the event is a workshop.',
  'userSponsorshipInfo.content.happyHour.li3':
    '2 attendees for the workshop at a subsidized price.',
  'userSponsorshipInfo.content.happyHour.li4':
    'Participation in a Raffle (you collect business cards from our attendees and participate in a drawing along with other vendors to giveaway any prize of your choice to the attendee).',
  'userSponsorshipInfo.content.happyHour.li5':
    'Your sponsorship is acknowledged in the meeting agenda.',
  'userSponsorshipInfo.content.happyHour.li6':
    'A two-minute informal oral advert/blurb about your company and its offerings to our attendees during the Happy Hour.',
  // Lunch Sponsorship
  'userSponsorshipInfo.content.lunchSponsorship.h1': 'Lunch Sponsorship:',
  'userSponsorshipInfo.content.lunchSponsorship.li1':
    'Vendor show tabletop space where you may display your company materials through the event.',
  'userSponsorshipInfo.content.lunchSponsorship.li2':
    'PDF Slide Deck of the presentations if the event is a workshop.',
  'userSponsorshipInfo.content.lunchSponsorship.li3':
    '2 attendees for the workshop at a subsidized price.',
  'userSponsorshipInfo.content.lunchSponsorship.li4':
    'Participation in a Raffle (you collect business cards from our attendees and participate in a drawing along with other vendors to giveaway any prize of your choice to the attendee).',
  'userSponsorshipInfo.content.lunchSponsorship.li5':
    'Two free lunches for your representatives.',
  'userSponsorshipInfo.content.lunchSponsorship.li6':
    'Your sponsorship is acknowledged in the meeting agenda.',
  'userSponsorshipInfo.content.lunchSponsorship.li7':
    'A two-minute informal oral advert/blurb about your company and its offerings to our attendees during lunch.',
  'userSponsorshipInfo.content.lunchSponsorship.li8':
    'Flyer distribution to advertise your company’s offerings on the lunch tables before attendees come in for lunch.',
  // Major Sponsorship
  'userSponsorshipInfo.content.major.h1': 'Major Sponsorship:',
  'userSponsorshipInfo.content.major.li1':
    'Exclusive vendor show tabletop space next to the workshop/symposium entrance where you may display your company materials through the event.',
  'userSponsorshipInfo.content.major.li2':
    '2 free workshop or symposium seats.',
  'userSponsorshipInfo.content.major.li3':
    'PDF Slide Deck of the presentations if the event is a workshop.',
  'userSponsorshipInfo.content.major.li4':
    'Participation in a Raffle (you collect business cards from our attendees and participate in a drawing along with other vendors to give away any prize of your choice to the attendee).',
  'userSponsorshipInfo.content.major.li5':
    'Two free lunches for your representatives.',
  'userSponsorshipInfo.content.major.li6':
    'A ten-minute oral podium slide presentation about your company and its offerings during the workshop/symposium.',
  'userSponsorshipInfo.content.major.li7':
    'Company flyer that advertises your company’s offerings will be emailed to the meeting attendees and will also be included in the workshop slide deck for all attendees.',
  'userSponsorshipInfo.content.major.li8':
    'Dinner invitation for 2 representatives to the post-meeting dinner for the organizers/speakers/sponsors.',
  'userSponsorshipInfo.content.major.li9':
    'You will receive the meeting attendees’ names and affiliations (their emails may be provided if they opted in during the registration process).',
  // Raffle Rules
  'userSponsorshipInfo.content.raffleRules.h1': 'Raffle Rules:',
  'userSponsorshipInfo.content.raffleRules.li1':
    'The raffle typically takes place at the end of the last break/vendor show session and before the final presentation session.',
  'userSponsorshipInfo.content.raffleRules.li2':
    'To minimize the raffle time, each participating vendor must pre-draw 3 winners’ names (one as the winner and the other two as backups), so that the winner’s name can be quickly announced.',
  'userSponsorshipInfo.content.raffleRules.li3':
    'Each vendor rep has 30 seconds to announce their name, company name and offerings.',
  'userSponsorshipInfo.content.raffleRules.li4':
    'Each vendor must give the prize(s) to one single winner.',
  'attendee-cart-screen-extra-message': ` <ul style="color: red; padding : 0px 10px ; margin: 0px;">
      <li>Please review carefully before clicking on the <b>Continue</b> button.</li>
      <li>Enter coupon code if you have one, then review carefully before clicking on continue button.</li>
    </ul>`,
  'sponsor-cart-screen-extra-message': ` <ul style="color: red; padding : 0px 10px ; margin: 0px;">
      <li>Add and save sponsor and vendor representative details before proceeding.</li>
      <li>Enter a coupon code if you have one, then review carefully before continuing.</li>
      <li>Please review all details carefully before clicking <b>Continue</b>.</li>
    </ul>`,
  'attendee-screen-extra-message': `
    <ul style="color: red; padding : 0px 10px ; margin: 0px;">
      <li>Add and save additional attendees before proceeding.</li>
      <li>Enter a coupon code if you have one, then review carefully before continuing.</li>
      <li>Some registration options require a qualification form before payment — complete it on this page when prompted.</li>
      <li>Please review all details carefully before clicking <b>Continue</b>.</li>
    </ul>
  `,
  'qualificationForm.modalTitle': 'Qualification form',
  'qualificationForm.embedHint':
    'Complete this form here. After you submit, we confirm it and continue to payment.',
  'qualificationForm.confirmingMessage':
    'Confirming your form submission. Please wait a moment.',
  'qualificationForm.notConfirmedMessage':
    'We have not yet confirmed your qualification form. Please submit the form and try again.',
  'qualificationForm.pendingAlert':
    'A qualification form is required for one or more attendees. Click Continue to complete the form on this page.',
  'qualificationForm.popupBlockedMessage':
    'Your browser blocked the qualification form pop-up. Please allow pop-ups for this site and try again.',
  'paymentCheckoutComponent.registration.extra': `
    <div style="color: red; padding : 0px 10px ; margin: 0px;">
      <span style="font-size: 14px;">You can modify your registration until 10 days before the event. Contact info@pbss.org for questions.</span>
    </div>
  `,
  'paymentCheckoutComponent.sponsor.major.extra': `
    <div style="color: red; padding : 0px 10px ; margin: 0px;">
      <span style="font-size: 14px;">You can modify your sponsorship registration and vendor reps until 7 days before the event. For changes within 7 days, please contact the PBSS admin or email us at info@pbss.org. Credit card processing fees are forfeited on refunds. Contact info@pbss.org for questions.</span>
    </div>
  `,
  'paymentCheckoutComponent.sponsor.non-major.extra': `
    <div style="color: red; padding : 0px 10px ; margin: 0px;">
      <span style="font-size: 14px;">You can modify your sponsorship registration and vendor reps until 7 days before the event. For changes within 7 days, please contact the PBSS admin or email us at info@pbss.org. Credit card processing fees are forfeited on refunds. Contact info@pbss.org for questions.</span>
    </div>
  `,
  'payment-success.registration.extra': `
     Credit card transaction fees will be deducted from any refund requests, regardless of when they are made. All refund requests must be made online at the My Events page after you log into your account. We hope that you can understand this policy, since we are a volunteer-run organization and have to minimize the effort our volunteers spend on dealing with such issues. Please note that the policy may vary depending on the chapter. Please contact info@pbss.org for questions.
  `,
  'payment-success.registration.extracontent1': `<ul><li class='extracontent1'>
            Meetings Attendees: All refund requests made by attendees must be received through the website at least three working days before the event begins. All refund transactions will be made in full, less any credit card processing fee.After the refund deadline, the registration payment becomes non-refundable.
            </li>
            <li class='extracontent1'>
              Major sponsorships: payments are refundable minus a $500 penalty up to 2 months prior to the date of the sponsored event. After the refund deadline, the sponsorship payment becomes non-refundable.
            </li>
            <li class='extracontent1'>
              Lunch sponsorships: payments are refundable minus a $300 penalty up to 2 months prior to the date of the sponsored event. After the refund deadline, the sponsorship payment becomes non-refundable.
            </li>
             <li class='extracontent1'>
Happy Hour sponsorships: payments are refundable minus a $300 penalty up to 2 months prior to the date of the sponsored event. After the refund deadline, the sponsorship payment becomes non-refundable.</li> 
             <li class='extracontent1'>
Vendor shows: payments are refundable minus a $100 penalty up to 2 weeks prior to the date of the sponsored event. After the refund deadline, the sponsorship payment becomes non-refundable.</li>
<li  class='extracontent1'>Credit card transaction fees will be deducted from any refund requests, regardless of when they are made. All refund requests must be made online at the My Events page after you log into your account. We hope that you can understand this policy, since we are a volunteer-run organization and have to minimize the effort our volunteers spend on dealing with such issues. Please note that the policy may vary depending on the chapter. Please contact info@pbss.org for questions.</li></ul>`,
  'payment-success.sponsor.major.extra': `
     You can modify your sponsorship registration and vendor reps until 7 days before the event. For changes within 7 days, please contact the PBSS admin or email us at info@pbss.org.
  `,
  'payment-success.sponsor.non-major.extra': `
     You can modify your sponsorship registration and vendor reps until 7 days before the event. For changes within 7 days, please contact the PBSS admin or email us at info@pbss.org.
  `,
  'userSponsorshipInfo.content.raffleRules.li5':
    'A person must be present to win.',
  'userSponsorshipInfo.content.raffleRules.contactUs': `For further details, please visit the individual PBSS chapters' pages
    via the PBSS home page, or email info@pbss.org.`,
  'addAttendeeComponent.option.registration': 'Registration',
  'addAttendeeComponent.option.food': 'Food',
  'addAttendeeComponent.button.webcastPopup.confirm':
    'Confirm webcast attendance',
  'addAttendeeComponent.button.webcastPopup.inPerson':
    'Choose in-person attendance',
  'addAttendeeComponent.button.webcastPopup.description':
    'Please note that webcast registration is only available for attendees who are not local to the event location. If you are local,you MUST choose in-person registration.',
  'addAttendeeComponent.button.webcastPopup.title':
    'Webcast Registration Confirmation',
  'addAttendeeComponent.sponsor.heroText.title': 'Attendee',
  'addAttendeeComponent.sponsor.heroText.subtitle': 'Attendee Registration',
  'addAttendeeComponent.contactUsFormComponent.heading': ' Contact us at',
  'addAttendeeComponent.contactUsFormComponent.email': 'info@pbss.org',
  'adsComponent.cart.payment.goBackButton': 'Go Back to Ads',
  'adsComponent.cart.payment.urlPath': 'ads',
  'adsComponent.cart.payment.tableTitle': 'ad',
  'adsComponent.cart.payment.totalAmountHeading': 'Total amount to be paid',
  'userAdsFormComponent.form.validation.vendorName':
    'Please fill out advertiser name',
  'userAdsFormComponent.form.placeholder.vendorName': 'Advertiser Name',
  'userAdsFormComponent.form.placeholder.attachmentURL':
    'External url / ad poster address (e.g. www.example.com)',
  'userAdsFormComponent.form.validation.attachmentURL':
    'Please fill out attachment URL',
  'userAdsFormComponent.form.validation.attachmentUrl.invalidFormat':
    'Invalid attachment URL format',
  'userAdsFormComponent.form.placeholder.email':
    "Submitter's email address(in case we need to contact you; not to be displayed in the ad)",
  'userAdsFormComponent.form.validation.email': 'Please fill out email',
  'userAdsFormComponent.form.validation.startDate': 'Please select start date',
  'userAdsFormComponent.form.placeholder.startDate': 'Start date of Ad',
  'userAdsFormComponent.form.placeholder.months':
    'Enter the number of months for ad duration, e.g. 1, 2 or 3.',
  'userAdsFormComponent.form.validation.adType': 'Please select ad type',
  'userAdsFormComponent.form.placeholder.adType': 'Select ads type',
  'userAdsFormComponent.form.placeholder.uploadLogo': 'Upload Logo',
  'userAdsFormComponent.form.validation.uploadLogo.acceptedFormats':
    'Accepts only image files (png, jpg, jpeg)',
  'userAdsFormComponent.form.placeholder.description':
    'Text of the ad (150 characters)',
  'userAdsFormComponent.form.placeholder.attachmentURL':
    'External url / ad poster address (e.g. www.example.com)',

  'userAdsFormComponent.form.validation.uploadLogo.maxSize': (fileType) => {
    return `Maximum file size is ${fileType}MB`;
  },
  'userAdsFormComponent.form.saveDraft': 'Save',
  'userAdsFormComponent.form.proceed': 'Proceed to Continue',
  'userAdsFormComponent.form.cancel': 'Cancel',
  'userCommonAdsListingCard.button.edit': 'Edit Ad',
  'userCommonAdsListingCard.search': 'Search for ads',
  'userCommonAdsListingCard.pageName': 'Ad',
  'userCommonAdsListingCard.selectPlaceholder': 'Status',
  'userCommonAdsListingCard.alert.title': 'No Ads Available',
  'userCommonAdsListingCard.viewMoreAds': 'View More Ads',
  'adsComponent.cart.payment.selectAdType': 'Ad Type',
  'adsComponent.cart.payment.months': 'Ad Months',
  'adsComponent.cart.payment.description': 'Ad Text',
  'userAssetsUploadComponent.uploadFile': 'Upload Flyer',
  'userAssetsUploadComponent.submit': 'Continue',

  // Pbss International Component
  'mainLayoutComponent.navbar.mainPage': 'Main Page',
  'mainLayoutComponent.navbar.aboutPbss': 'About',
  'mainLayoutComponent.navbar.aboutPbss.pbss': 'PBSS',
  'mainLayoutComponent.navbar.events': 'Events',
  'mainLayoutComponent.navbar.pickALocation': 'Pick a Location',
  'mainLayoutComponent.navbar.pbssInternational': 'PBSS International',
  'mainLayoutComponent.navbar.eventTypesInfo': 'Event Types Info',
  'mainLayoutComponent.navbar.eventTypesInfo.seminarLuncheons':
    'Seminar Luncheons',
  'mainLayoutComponent.navbar.eventTypesInfo.workshops': 'Workshops',
  'mainLayoutComponent.navbar.eventTypesInfo.symposia': 'Symposia',
  'mainLayoutComponent.navbar.eventTypesInfo.webinars': 'Webinars',
  'mainLayoutComponent.navbar.eventTypesInfo.dinnerSeminars': 'Dinner Seminars',
  'mainLayoutComponent.navbar.sponsorships': 'Sponsorships',
  'mainLayoutComponent.navbar.chapters': 'Chapters',
  'mainLayoutComponent.navbar.contactUs': 'Contact Us',
  'mainLayoutComponent.navbar.jobPostings': 'Job Postings',
  'mainLayoutComponent.navbar.adPostings': 'Ads',
  'mainLayoutComponent.navbar.resources': 'Resources',
  'mainLayoutComponent.navbar.resources.stemOutreach': 'STEM outreach',
  'mainLayoutComponent.navbar.resources.industryOutreach': 'Industry News',
  'mainLayoutComponent.navbar.resources.careerMentorship': 'Career Mentorship',
  'mainLayoutComponent.navbar.resources.partners':
    'Partner Organizations of PBSS',
  'mainLayoutComponent.navbar.faq': 'FAQ',

  // Profile View
  'profileViewComponent.heading': 'ACCOUNT',
  'profileViewComponent.subheading': 'Switch to Admin Functions',
  'profileViewComponent.button.changePassword': 'Change Password',
  'profileViewComponent.button.createJobPosting': 'Post or Manage a Job',
  'profileViewComponent.button.createAd': 'Post or Manage an Ad',
  'profileViewComponent.button.myCart': 'My Cart',
  'profileViewComponent.button.myEvents': 'My Event(s)',
  'profileViewComponent.button.updateProfile': 'Update Profile',
  'profileViewComponent.button.joinPbss': 'Join PBSS',
  'profileViewComponent.button.logout': 'Logout',
  'profileViewComponent.button.login': 'Login',
  'profileViewComponent.button.myAccount': 'My Account',

  // Pbss In Map
  'pbssInMapComponent.specialAnnouncementHeading': 'Special Announcement',

  // Jobs And Ads Tabs
  'jobsAndAdsTabs.ads': 'Paid Advertisements',
  'jobsAndAdsTabs.jobs': 'Job Postings',

  //Event Listing
  'eventListing.regClosed.title': 'Registration Closed',
  'eventListing.regClosed.message':
    'The registrations for this event is closed, please reach out to the admin at ',
  'eventListing.regClosed.email': 'info@pbss.org',
  'eventListing.regClosed.moreInfo': 'for more information.',
  'eventListing.regOpen.title': 'Register Now',
  'eventListing.regClosed.title': 'Registration Closed',
  'eventListing.speaker': 'Speaker',
  'eventListing.comingSoon': 'Coming Soon',

  //Past Events Listing
  'pastEventsListing.title': 'Past Events',

  //Sponsor Listing
  'sponsorListing.title': 'Event Sponsors',

  //Footer
  'footer.text': `© ${new Date().getFullYear()} All rights reserved, Pharmaceutical & BioScience Society International.`,
  'footer.links.aboutUs': 'About Us',
  'footer.links.contactUs': 'Contact Us',
  'footer.links.jobs': 'Jobs',
  'footer.links.ads': 'Ads',
  'footer.links.subscribe': 'Subscribe to Newsletter',
  'footer.links.privacyPolicy':
    'By subscribing, you agree to our Privacy Policy.',

  //Chapter Page
  'chapterPage.otherChapterEventData.title':
    'Webcast of Upcoming Events from Other Chapters',
  'chapterPage.eventChapter.title': 'Upcoming',
  'chapterPage.eventChapter.title2': 'Events',

  //Admin Actions Dropdown Component
  'adminActionsDropdownComponent.deleteText': 'Delete',
  'adminActionsDropdownComponent.cancelText': 'Cancel',
  'adminActionsDropdownComponent.saveText': 'Save',
  'adminActionsDropdownComponent.editText': 'Edit',
  'adminActionsDropdownComponent.addEditChapterContent':
    'Add/Edit Chapter Content',
  'adminActionsDropdownComponent.editSponsorshipInfo': 'Edit Sponsorship Info',
  'adminActionsDropdownComponent.viewText': 'View',
  'adminActionsDropdownComponent.copyText': 'Copy',
  'adminActionsDropdownComponent.changeStatusText.part1': 'Change',
  'adminActionsDropdownComponent.changeStatusText.part2': 'Status',
  'adminActionsDropdownComponent.changeWillReceiveText.part1': 'Change',
  'adminActionsDropdownComponent.changeWillReceiveText.part2': 'Email Updates',
  'adminActionsDropdownComponent.eventRegistration': 'Registration',
  'adminActionsDropdownComponent.eventRegistrationWaitingList': 'Waiting List',
  'adminActionsDropdownComponent.eventOptions': 'Options',
  'adminActionsDropdownComponent.eventEmailScheduler': 'Email Scheduler',
  'adminActionsDropdownComponent.eventEmailScheduler.noTemplateData':
    'No template data found.',
  'adminActionsDropdownComponent.eventEmailScheduler.backToScheduler':
    'Back To Event Email Template Scheduler',
  'adminActionsDropdownComponent.eventRefund': 'Refund',
  'adminActionsDropdownComponent.viewCouponUsers': 'View Coupon Users',
  'adminActionsDropdownComponent.editEmailTemplate': 'Edit Email Template',
  'adminActionsDropdownComponent.editScheduleOfTemplate':
    'Edit Schedule of Template',
  'adminActionsDropdownComponent.sendDirectEmail': 'Send Direct Email',
  'adminActionsDropdownComponent.sendDirectEmailConfirmTitle':
    'Send direct email',
  'adminActionsDropdownComponent.sendDirectEmailConfirmDescription':
    'Are you sure you want to send this email?',
  'adminActionsDropdownComponent.sendDirectEmailSecondConfirmDescription':
    "This email will be sent immediately to all selected recipients. Click 'Yes' to proceed or 'Cancel' to cancel.",
  'adminActionsDropdownComponent.editAttendee': 'Edit Attendee',
  'adminActionsDropdownComponent.deleteAttendee': 'Delete Attendee',
  'adminActionsDropdownComponent.cancelAttendee': 'Cancel Attendee',
  'adminActionsDropdownComponent.saveAttendee': 'Save Attendee',

  //Confirmation Action Component
  'adminActionsDropdownComponent.addAdditionalAttendee':
    'Add Additional Attendee',
  'adminActionsDropdownComponent.addAdditionalAttendee.vendorRepLimitExhausted':
    'You have reached the maximum number of vendor reps.',
  'adminActionsDropdownComponent.addAdditionalAttendee.vendorRepLimitExhausted.title':
    'Vendor Rep Limit Exhausted.',

  //Attendees Cart Component
  'userAttendeeCartComponent.credit.totalAmountToBePaid': 'TOTAL',
  'userAttendeeCartComponent.credit.subtotal': 'Subtotal',
  'userAttendeeCartComponent.credit.discount': 'Discount',
  'userAttendeeCartComponent.credit.useCredit': 'Use credit',

  //Add Attendee Component
  'userAddAttendeeComponent.goBackToEventDetails': 'Go Back to Event Details',

  //Chapter Page
  'chapterPage.chapterHeading.pbss': 'Pharmaceutical & BioScience Society,',
  'chapterPage.chapterHeading.welcome': 'Welcome to the',
  'chapterPage.chapterHeading.pbssInternational':
    'chapter of PBSS International',
  'chapterPage.chapterHeading.pbssInternational.seattle': 'Seattle',
  'chapterPage.chapterHeading.pbssInternational.boston': 'Boston',
  'chapterPage.chapterHeading.pbssInternational.vancouver': 'Vancouver',
  'chapterPage.chapterHeading.pbssInternational.korea': 'Korea',
  'chapterPage.chapterHeading.pbssInternational.japan': 'Japan',
  'chapterPage.chapterHeading.pbssInternational.china': 'China',
  'chapterPage.chapterHeading.pbssInternational.india': 'India',
  'chapterPage.chapterHeading.pbssInternational.default':
    'Pharmaceutical & BioScience Society International',
  'chapterPage.chapterHeading.pbss.japan':
    'Pharmaceutical & BioScience Society,',
  'chapterPage.chapterHeading.welcome.japan': 'Welcome to the',
  'chapterPage.chapterHeading.pbssInternational.japan':
    'chapter of PBSS International',

  //Event Listing
  'eventListing.filterBy': 'Filter by',
  'eventListing.eventType': 'Event Type',
  'eventListing.chapter': 'Chapter',
  'eventListing.date': 'Date',
  'eventListing.year': 'Year',
  'jobListing.selectYear': 'Year',
  'jobListing.selectDefaultYear': 'Select Year',
  'eventListing.all': 'All',
  'eventListing.selectDefaultChapter': 'Select your Default chapter',
  'eventListing.selectDefaultStatus': 'Select your default status',
  'eventListing.selectDefaultLocation': 'Select your default location',
  'eventListing.selectLocation': 'Job Location',
  'eventListing.selectDefaultCategory': 'Select your default category',
  'eventListing.selectDefaultYear': 'Select Year',
  'eventListing.selectYear': 'Year',
  'eventListing.history': 'History',
  'eventListing.searchByEventName': 'Search by event name',
  'eventListing.clearFilter': 'Clear Filter',
  'eventListing.attended': 'Attended',
  'eventListing.upcoming': 'Upcoming',
  'jobListing.clearFilter': 'Clear Filter',

  //Sponsor Info Details Component
  'sponsorInfoDetailsComponent.title': 'Sponsorship Info',
  'sponsorInfoDetailsComponent.content.vendorShowExhibition.title':
    'Vendor Show Exhibition',
  'sponsorInfoDetailsComponent.content.happyHourSponsorship.title':
    'Happy Hour Sponsorship',
  'sponsorInfoDetailsComponent.content.lunchSponsorship.title':
    'Lunch Sponsorship',
  'sponsorInfoDetailsComponent.content.majorSponsorship.title':
    'Major Sponsorship',
  'sponsorInfoDetailsComponent.content.raffleRules.title': 'Raffle Rules',
  'sponsorInfoDetailsComponent.content.cancellationPolicy.title':
    'Cancellation Policy',
  'sponsorInfoDetailsComponent.content.vendorShowExhibition': `<p class='sponsorshipInfo'>Participation in an in-person PBSS event as an exhibitor.</p>
              <p class='sponsorshipInfo'>Your registration fee includes:</p>
              <ol class='sponsorshipInfoOrderedList'>
                <li class='sponsorshipInfoList'>
                  Vendor show tabletop space where you may display your company
                  materials through the event.
                </li>
                <li class='sponsorshipInfoList'>2 attendees for the workshop at a subsidized price.</li>
                <li class='sponsorshipInfoList'>
                  PDF Slide Deck of the presentations if the event is a workshop.
                </li>
                <li class='sponsorshipInfoList'>
                  Participation in a Raffle (you collect business cards from our
                  attendees and participate in a drawing along with other vendors
                  to giveaway any prize of your choice to the attendee).
                </li>
              </ol>
              <p class='sponsorshipInfo'>
                For further details please contact
                <a href="mailto:info@pbss.org">info@pbss.org</a>
              </p>`,
  'sponsorInfoDetailsComponent.content.happyHourSponsorship': `
            <p class='sponsorshipInfo'>
              Participation in an in-person PBSS event as a Happy Hour Sponsor.
            </p>
            <p class='sponsorshipInfo'>Your registration includes:</p>
            <ol class='sponsorshipInfoOrderedList'>
              <li class='sponsorshipInfoList'>
                Vendors show tabletop space where you may display your company
                materials through the event.
              </li>
              <li class='sponsorshipInfoList'>
                PDF Slide Deck of the presentations if the event is a workshop.
              </li>
              <li class='sponsorshipInfoList'>2 attendees for the workshop at a subsidized price.</li>
              <li class='sponsorshipInfoList'>
                Participation in a Raffle (you collect business cards from our
                attendees and participate in a drawing along with other vendors
                to give away any prize of your choice to the attendee).
              </li>
              <li class='sponsorshipInfoList'>Your sponsorship is acknowledged in the meeting agenda.</li>
              <li class='sponsorshipInfoList'>
                A two-minute informal oral advert/blurb about your company and
                its offerings to our attendees during the Happy Hour.
              </li>
            </ol>
            <p class='sponsorshipInfo'>
                For further details please contact
                <a href="mailto:info@pbss.org">info@pbss.org</a>
              </p>
          `,
  'sponsorInfoDetailsComponent.content.lunchSponsorship': `<p class='sponsorshipInfo'>Participation in an in-person PBSS event as a Lunch Sponsor.</p>
            <p class='sponsorshipInfo'>Your registration fee includes:</p>
            <ol class='sponsorshipInfoOrderedList'>
              <li class='sponsorshipInfoList'>
                Vendor show tabletop space where you may display your company
                materials throughout the event.
              </li>
              <li class='sponsorshipInfoList'>
                PDF Slide Deck of the presentations if the event is a workshop.
              </li>
              <li class='sponsorshipInfoList'>2 attendees for the workshop at a subsidized price.</li>
              <li class='sponsorshipInfoList'>
                Participation in a Raffle (you collect business cards from our
                attendees and participate in a drawing along with other vendors
                to give away any prize of your choice to the attendee).
              </li>
              <li class='sponsorshipInfoList'>Two free lunches for your representatives.</li>
              <li class='sponsorshipInfoList'>Your sponsorship is acknowledged in the meeting agenda.</li>
              <li class='sponsorshipInfoList'>
                A two-minute informal oral advert/blurb about your company and
                its offerings to our attendees during lunch.
              </li>
              <li class='sponsorshipInfoList'>
                Flyer distribution to advertise your company’s offerings on the
                lunch tables before attendees come in for lunch.
              </li>
            </ol>
            <p class='sponsorshipInfo'>
                For further details please contact
                <a href="mailto:info@pbss.org">info@pbss.org</a>
              </p>`,
  'sponsorInfoDetailsComponent.content.majorSponsorship': `<p class='sponsorshipInfo'>Participation in an in-person PBSS event as a Major Sponsor.</p>
            <p class='sponsorshipInfo'>Your registration fee includes:</p>
            <ol class='sponsorshipInfoOrderedList'>
              <li class='sponsorshipInfoList'>
                Exclusive vendor show tabletop space next to the
                workshop/symposium entrance where you may display your company
                materials through the event.
              </li>
              <li class='sponsorshipInfoList'>2 free workshop or symposium seats.</li>
              <li class='sponsorshipInfoList'>
                PDF Slide Deck of the presentations if the event is a workshop.
              </li>
              <li class='sponsorshipInfoList'>
                Participation in a Raffle (you collect business cards from our
                attendees and participate in a drawing along with other vendors
                to give away any prize of your choice to the attendee).
              </li>
              <li class='sponsorshipInfoList'>Two free lunches for your representatives.</li>
              <li class='sponsorshipInfoList'>
                A ten-minute oral podium slide presentation about your company
                and its offerings during the workshop/symposium.
              </li>
              <li class='sponsorshipInfoList'>
                Company flyer that advertises your company’s offerings will be
                emailed to the meeting attendees and will also be included in
                the workshop slide deck for all attendees.
              </li>
              <li class='sponsorshipInfoList'>
                Dinner invitation for 2 representatives to the post-meeting
                dinner for the organizers/speakers/sponsors.
              </li>
              <li class='sponsorshipInfoList'>
                You will receive the meeting attendees’ names and affiliations
                (their emails may be provided if they opted in during the
                registration process).
              </li>
            </ol>
            <p class='sponsorshipInfo'>
                For further details please contact
                <a href="mailto:info@pbss.org">info@pbss.org</a>
              </p>`,

  'sponsorInfoDetailsComponent.content.raffleRules': `<ul><li class='sponsorshipInfoList'>
              The raffle typically takes place at the end of the last
              break/vendor show session and before the final presentation
              session.
            </li>
            <li class='sponsorshipInfoList'>
              To minimize the raffle time, each participating vendor must
              pre-draw 3 winners’ names (one as the winner and the other two as
              backups), so that the winner’s name can be quickly announced.
            </li>
            <li class='sponsorshipInfoList'>
              Each vendor rep has 30 seconds to announce their name, company
              name and offerings.
            </li>
            <li class='sponsorshipInfoList'>Each vendor must give the prize(s) to one single winner.</li>
            <li class='sponsorshipInfoList'>A person must be present to win.</li></ul>`,
  'sponsorInfoDetailsComponent.content.cancellationPolicy': `<ul><li class='sponsorshipInfoList'>
            Meetings Attendees: All refund requests made by attendees must be received through the website at least three working days before the event begins. All refund transactions will be made in full, less any credit card processing fee. After the refund deadline, the registration payment becomes non-refundable.
            </li>
            <li class='sponsorshipInfoList'>
              Major sponsorships: payments are refundable minus a $500 penalty up to 2 months prior to the date of the sponsored event. After the refund deadline, the sponsorship payment becomes non-refundable.
            </li>
            <li class='sponsorshipInfoList'>
              Lunch sponsorships: payments are refundable minus a $300 penalty up to 2 months prior to the date of the sponsored event. After the refund deadline, the sponsorship payment becomes non-refundable.
            </li>
             <li class='sponsorshipInfoList'>
Happy Hour sponsorships: payments are refundable minus a $300 penalty up to 2 months prior to the date of the sponsored event. After the refund deadline, the sponsorship payment becomes non-refundable.</li> 
             <li class='sponsorshipInfoList'>
Vendor shows: payments are refundable minus a $100 penalty up to 2 weeks prior to the date of the sponsored event. After the refund deadline, the sponsorship payment becomes non-refundable.</li>
<li  class='sponsorshipInfoList'>Credit card transaction fees will be deducted from any refund requests, regardless of when they are made. All refund requests must be made online at the My Events page after you log into your account. We hope that you can understand this policy, since we are a volunteer-run organization and have to minimize the effort our volunteers spend on dealing with such issues. Please note that the policy may vary depending on the chapter. Please contact <a href="mailto:info@pbss.org">info@pbss.org</a> for questions.</li></ul>`,

  // Faq Component
  'faqComponent.title': 'Frequently Asked Questions',
  'faqComponent.contactUs': 'Contact Us:',
  'faqComponent.contactUs.link': 'Click here',
  'faqComponent.contactUs.email': 'info@pbss.org',
  'faqComponent.faq.content.title': 'Is there a membership fee to join PBSS?',
  'faqComponent.faq.content.description': 'No. Membership is free.',
  'faqComponent.faq.content.title2': 'What is PBSS policy on vendor speakers?',
  'faqComponent.faq.content.description2': `We often receive interest from vendors in providing a speaker for one of our meetings. Unfortunately, in order to avoid any impression of commercial promotion or vendor favoritism, the PBSS policy generally prohibits the use of vendor speakers, except in rare cases where a vendor holds a unique technology that we are interested in hearing about. One compromise solution is that vendors can recommend a client scientist who is an expert on the vendor's technology.`,
  'faqComponent.faq.content.title3':
    'What is PBSS policy on membership information sharing?',
  'faqComponent.faq.content.description3': `In order to protect the privacy of our members, the membership list is strictly used for PBSS business only and cannot be shared with anyone or any party outside PBSS management.`,
  'faqComponent.faq.content.title4':
    'Will PBSS provide an Attendance Certificate?',
  'faqComponent.faq.content.description4': `<p>We can provide an electronic copy (PDF) of the attendance certificate upon special request at an extra cost, typically $50 for US-based events. Please email us at <a href="mailto:info@pbss.org">info@pbss.org</a> and indicate the date and title of the event. </p>`,
  'faqComponent.faq.content.title5': 'What is PBSS Cancellation Policy?',
  'faqComponent.faq.content.description5': `
  <p>Meetings Attendees: All refund requests made by attendees must be received through the website at least three working days before the event begins. All refund transactions will be made in full, less any credit card processing fee. After the refund deadline, the registration payment becomes non-refundable.</p>
  <p>Major sponsorships: payments are refundable minus a $500 penalty up to 2 months prior to the date of the sponsored event. After the refund deadline, the sponsorship payment becomes non-refundable.</p>
  <p>Lunch sponsorships: payments are refundable minus a $300 penalty up to 2 months prior to the date of the sponsored event. After the refund deadline, the sponsorship payment becomes non-refundable.</p>
  <p>Happy Hour sponsorships: payments are refundable minus a $300 penalty up to 2 months prior to the date of the sponsored event. After the refund deadline, the sponsorship payment becomes non-refundable.</p>
  <p>Vendor shows: payments are refundable minus a $100 penalty up to 2 weeks prior to the date of the sponsored event. After the refund deadline, the sponsorship payment becomes non-refundable.</p>
  <P>Credit card transaction fees will be deducted from any refund requests, regardless of when they are made. All refund requests must be made online at the My Events page after you log into your account. We hope that you can understand this policy, since we are a volunteer-run organization and have to minimize the effort our volunteers spend on dealing with such issues. Please note that the policy may vary depending on the chapter. Please contact info@pbss.org for questions.</p>`,
  'faqComponent.contactUs.or': 'or email to',
  // User Update Profile Component
  'userUpdateProfileComponent.first_name.validationMessage':
    'First name should not be empty',
  'userUpdateProfileComponent.first_name.placeholder': 'Enter your first name',
  'userUpdateProfileComponent.title.validationMessage':
    'Title should not be empty',
  'userUpdateProfileComponent.title.placeholder': 'Enter your title',
  'userUpdateProfileComponent.address.validationMessage':
    'Address should not be empty',
  'userUpdateProfileComponent.address.placeholder': 'Enter your address',
  'userUpdateProfileComponent.city.validationMessage':
    'City should not be empty',
  'userUpdateProfileComponent.city.placeholder': 'Enter your city name',
  'userUpdateProfileComponent.notes.placeholder': 'Enter your notes',
  'userUpdateProfileComponent.last_name.validationMessage':
    'Last name should not be empty',
  'userUpdateProfileComponent.last_name.placeholder': 'Enter your last name',
  'userUpdateProfileComponent.company.validationMessage':
    'Company should not be empty',
  'userUpdateProfileComponent.company.placeholder': 'Enter your company name',
  'userUpdateProfileComponent.address2.validationMessage':
    'Address should not be empty',
  'userUpdateProfileComponent.address2.placeholder': 'Enter your address',
  'userUpdateProfileComponent.state.placeholder': 'State / Province / Region',
  'userUpdateProfileComponent.postal_code.placeholder':
    'Enter your postal code',
  'userUpdateProfileComponent.phone_number.placeholder':
    'Enter your phone number',
  'userUpdateProfileComponent.local_chapter_id.validationMessage':
    'Local chapter should not be empty',
  'userUpdateProfileComponent.local_chapter_id.placeholder':
    'Select your default chapter',
  'userUpdateProfileComponent.email.validationMessage':
    'Email should not be empty',
  'userUpdateProfileComponent.email.placeholder': 'Enter your email',
  'userUpdateProfileComponent.mail_preference.validationMessage':
    'Mail preference should not be empty',
  'userUpdateProfileComponent.mail_preference.placeholder':
    'Select your mail preference',
  'userUpdateProfileComponent.mail_preference.label':
    'Select a PBSS Chapter(s) to receive its announcements',
  'userUpdateProfileComponent.mail_preference.emptyStateInfo':
    'If you select any chapter, you will automatically receive all emails.',
  'userUpdateProfileComponent.area_of_interest.label':
    'Select Area(s) of Interest',
  'userUpdateProfileComponent.area_of_interest.placeholder':
    'Select area(s) of interest',
  'userUpdateProfileComponent.area_of_interest.validationMessage':
    'Area of interest should not be empty',
  'userUpdateProfileComponent.update_profile': 'Update Profile',
  'userUpdateProfileComponent.cancel': 'Cancel',
  'userUpdateProfileComponent.area_of_interest.label2':
    'You can add other interest in following textbox , use comma for separation of multiple options',
  'userUpdateProfileComponent.email.textMessage':
    'Contact us to change your email on the account,',
  'userUpdateProfileComponent.local_chapter_id.label':
    'Select Your Local Default Chapter',
  'userUpdateProfileComponent.phone_number.label': 'Phone Number',
  'userUpdateProfileComponent.postal_code.label': 'Postal Code',
  'userUpdateProfileComponent.state.label': 'State',
  'userUpdateProfileComponent.address2.label': 'Address Line 2',
  'userUpdateProfileComponent.company.label': 'Company Name/Affiliation',
  'userUpdateProfileComponent.last_name.label': 'Last Name',
  'userUpdateProfileComponent.notes.label': 'Notes',
  'userUpdateProfileComponent.city.label': 'City',
  'userUpdateProfileComponent.country.label': 'Country',
  'userUpdateProfileComponent.address.label': 'Address Line 1',
  'userUpdateProfileComponent.first_name.label': 'First Name',
  'userUpdateProfileComponent.title.label': 'Title',
  'userUpdateProfileComponent.subheading':
    'Pharmaceutical & Bioscience Society',
  'userUpdateProfileComponent.update_profile': 'Update Profile',
  'userUpdateProfileComponent.country.validationMessage':
    'Country should not be empty',
  'userUpdateProfileComponent.country.placeholder': 'Select your country',
  'userUpdateProfileComponent.country.area_of_interest.label':
    'Enter areas of interest, separated by comma',
  'userUpdateProfileComponent.country.area_of_interest.validationMessage':
    'Area of interest should not be empty',

  //Change Password
  'changePasswordForm.old_password.validationMessage':
    'Please input your old password',
  'changePasswordForm.new_password.validationMessage':
    'Please input your new password',
  'changePasswordForm.old_password.placeholder': 'Enter your old password',
  'changePasswordForm.new_password.placeholder': 'Enter your new password',
  'changePasswordForm.confirm_password.placeholder':
    'Enter your confirm password',
  'changePasswordForm.old_password.label': 'Old Password',
  'changePasswordForm.new_password.label': 'New Password',
  'changePasswordForm.change_password': 'Change Password',

  //Jobs
  'userJobsComponent.pageName': 'Job',
  'userJobsComponent.heading': 'Add New Job',
  'userJobsComponent.uploadLogoText': 'Upload Logo',
  'userJobsComponent.paymentText':
    'Please complete the payment process to advance in the posting process.',
  'userJobsComponent.position.validationMessage': 'Please fill out position',
  'userJobsComponent.position.placeholder': 'Position / Designation',
  'userJobsComponent.employer.validationMessage':
    'Please fill out employer name',
  'userJobsComponent.employer.placeholder': 'Employer name',
  'userJobsComponent.location.validationMessage': 'Please fill out location',
  'userJobsComponent.location.placeholder': 'Location',
  'userJobsComponent.contact_info.placeholder': 'Contact information',
  'userJobsComponent.attachment_url.validationMessage':
    'Please fill out attachment url or email',
  'userJobsComponent.attachment_url.placeholder':
    'Apply Now Destination (URL or Email)',
  'userJobsComponent.start_date.validationMessage': 'Please select start date',
  'userJobsComponent.start_date.placeholder': 'Start date of Job',
  'userJobsComponent.months.placeholder':
    'Enter the number of months for ad duration, e.g., 1, 2 or 3',
  'userJobsComponent.job_fee_id.validationMessage': 'Please select job type',
  'userJobsComponent.job_fee_id.placeholder': 'Select job type',
  'userJobsComponent.description.validationMessage':
    'Please fill out description',
  'userJobsComponent.description.placeholder': 'Job Description',
  'userJobsComponent.requirement.validationMessage':
    'Please fill out requirement',
  'userJobsComponent.requirement.placeholder': 'Job Requirements',
  'userJobsComponent.submit&CheckoutText': 'Submit & Checkout',
  'userJobsComponent.save': 'Save',

  //Jobs Cart
  'userJobsComponent.goBackToJobPosting': 'Go Back to Job Posting',
  'userJobsComponent.totalAmountToBePaid': 'Total amount to be paid',
  'userJobsComponent.pageName': 'Job',
  'userJobsComponent.submit&CheckoutText': 'Proceed & Confirm',

  //Jobs Cart Table
  'userJobsComponent.employer.label': 'Employer Name',
  'userJobsComponent.position.label': 'Position',
  'userJobsComponent.job_fee_id.label': 'Job Type',
  'userJobsComponent.months.label': 'Job Months',
  'userJobsComponent.fees.label': 'Fees',
  'userJobsComponent.job_fee_id.validationMessage':
    'Job fee type should not be empty',
  'userJobsComponent.job_fee_id.placeholder': 'Select job type',
  'userJobsComponent.months.validationMessage':
    'Job months should not be empty',
  'userJobsComponent.months.placeholder':
    'Enter the number of months for ad duration, e.g., 1, 2 or 3',
  'userJobsComponent.employer.validationMessage':
    'Employer should not be empty',
  'userJobsComponent.cart.employer.placeholder': 'Enter your employer',
  'userJobsComponent.position.validationMessage':
    'Position should not be empty',
  'userJobsComponent.cart.position.placeholder': 'Enter your position',
  'userJobsComponent.job_fee_id.placeholder': 'Select job advertisement type',
  'userJobsComponent.job_fee_id.validationMessage':
    'Job fee type should not be empty',
  'userJobsComponent.months.validationMessage':
    'Job months should not be empty',
  'userJobsComponent.months.placeholder': 'Duration of Job Post (in months)',

  //Jobs Cart
  'userJobsCartComponent.heading': 'Jobs Payment Method',
  'userJobsCartComponent.subheading':
    'Get Details about jobs payment price , schedule & more...',

  //Common Payment Checkout Form
  'specialPaymentFormComponent.payWithCreditCard':
    'Pay by card or digital wallet',
  'specialPaymentFormComponent.payWithApplePay': 'Pay with Apple Pay',
  'specialPaymentFormComponent.creditCardProcessingFeeNotice':
    'As a non-profit society that operates on a small budget, we try to minimize operational costs whenever possible. Our payment processor charges us over 2.9% for card and digital wallet payments and these fees do add up to a significant amount each year. We greatly appreciate your help in covering part of the processing fee. Alternatively, to avoid this fee, you can select a bank-related payment option, which has a much smaller fee for us.',
  'specialPaymentFormComponent.applePayProcessingFeeNotice':
    'As a non-profit society that operates on a small budget, we try to minimize operational costs whenever possible. Our Apple Pay payment processor charges us over 2.9% for Apple Pay payments and these fees do add up to a significant amount each year. We greatly appreciate your help in covering part of the processing fee. Alternatively, to avoid this fee, you can select the bank transfer option, which has a much smaller fee for us.',
  'specialPaymentFormComponent.confirmAndPay': 'Confirm & Pay',
  'specialPaymentFormComponent.confirmAndPay.japanese': '確認して支払う',
  'specialPaymentFormComponent.confirmAndPay.english': 'Confirm & Pay',
  'userAttendeeCartComponent.credit.coverProcessingFeeBeforeAmount':
    'I agree to cover the payment processing fee (2.9%)',
  'userAttendeeCartComponent.applePay.coverProcessingFeeBeforeAmount':
    'I agree to cover the Apple Pay processing fee (2.9%)',
  'userAttendeeCartComponent.credit.coverProcessingFeeAfterAmount':
    '. This fee is non-refundable.',

  //Common Ads Listing Card
  'userCommonAdsListingCard.button.pay': 'Pay',
  'userCommonAdsListingCard.button.edit': 'Edit Ad',
  'userCommonAdsListingCard.button.checkItOut': 'Check It Out',
  'userCommonAdsListingCard.button.delete': 'Delete Ad',

  //Ads Cart
  'adsComponent.cart.payment.vendor': 'Advertiser Name',
  'adsComponent.cart.payment.description': 'Ad Text',
  'adsComponent.cart.payment.adType': 'Ad Type',
  'adsComponent.cart.payment.months': 'Ad Duration (months)',
  'adsComponent.cart.payment.fees': 'Fee',

  //Common Hero Text
  'commonHeroText.availableCredit': 'Available Credit',

  //My Event Listing To Be Paid
  'myEventListingToBePaid.placeHolder': 'Search by event name',

  //My Event Card
  'myEventCard.registrationClosed':
    "We're sorry, but registration is closed for this event. You'll be added to the waiting list.",
  'myEventCard.pleaseSelectAttendee': 'Please select attendee(s)',
  'myEventCard.askForRefund': 'Ask for Refund',
  'myEventCard.editRegistration': 'Edit Registration',
  'myEventCard.completePayment': 'Complete Payment',
  'myEventCard.payInCart': 'Pay in Cart',

  //Event Details Modal
  'userEventDetailsModal.refundMode.pbssCredit': 'PBSS Credit',
  'userEventDetailsModal.refundMode.refundToBank': 'Refund to Bank',
  'userEventDetailsModal.name': 'Name',
  'userEventDetailsModal.email': 'Email',
  'userEventDetailsModal.registrationType': 'Registration Type',
  'userEventDetailsModal.sponsorshipType': 'Sponsorship Type',
  'userEventDetailsModal.date': 'Date',
  'userEventDetailsModal.companyAffiliation': 'Company/Affiliation',
  'userEventDetailsModal.department': 'Department',
  'userEventDetailsModal.jobTitle': 'Job Title',
  'userEventDetailsModal.refundedAmount': 'Refunded Amount',
  'userEventDetailsModal.refundType': 'Refund Type',
  'userEventDetailsModal.registrationStatus': 'Registration Status',
  'userEventDetailsModal.paid': 'Paid',
  'userEventDetailsModal.paymentConfirmed': 'Payment Confirmed',
  'userEventDetailsModal.feeWaiver': 'Fee Waiver',
  'userEventDetailsModal.registrationCancelled': 'Registration Cancelled',
  'userEventDetailsModal.paymentRefunded': 'Payment Refunded',
  'userEventDetailsModal.refundPending': 'Refund Pending',
  'userEventDetailsModal.noChargeEvent': 'No Charge Event',
  'userEventDetailsModal.paymentProcessing': 'Payment Processing',
  'userEventDetailsModal.toBePaid': 'To Be Paid',
  'userEventDetailsModal.attendanceType': 'Attendance Type',
  'userEventDetailsModal.cost': 'Paid amount',
  'userEventDetailsModal.modeOfRefund': 'Mode of Refund',
  'userEventDetailsModal.totalCost': 'Paid amount',
  'userEventDetailsModal.paymentDate': 'Payment Date',
  'userEventDetailsModal.processingFee': 'Processing Fee (2.9%)',
  'userEventDetailsModal.processingFeeTooltip':
    'This processing fee is not refundable.',
  'userEventDetailsModal.askForRefund': 'Ask for Refund',
  'userEventDetailsModal.payment': 'Payment',

  //My Event Listing To Be Paid
  'myEventListingToBePaid.noEventsAvailable': 'No Events Available',

  //My Event Card
  'myEventCard.refund': 'Refund',
  'myEventCard.selectAttendeeForRefund': 'Select Attendee For Refund',
  'myEventCard.cancelRegistration': 'Cancel Registration',
  'myEventCard.selectAttendeeForCancellation':
    'Select Attendee For Cancellation',

  //My Event Listing
  'myEventListing.pageName': 'My Event',
  'myEventListing.status': 'Status',
  'myEventListing.searchPlaceholder': 'Search by event name',
  'myEventListing.noWaitingListAvailable': 'No Waiting List Available',
  'myEventListing.noEventsAvailable': 'No Events Available',

  //EventType Filter
  'eventTypeFilter.regularRegistration': 'Regular Registration',
  'eventTypeFilter.sponsorshipRegistration': 'Sponsorship Registration',
  'eventTypeFilter.waitingListRegistration': 'Waiting List Registrations',

  //Receipt Component
  'receiptComponent.error.contentNotReady': 'Content is not ready yet',
  'receiptComponent.error.eventDataMissing': 'Event data is not available',
  'receiptComponent.registrationReceipt': 'Registration Receipt',
  'receiptComponent.adReceipt': 'Ad Receipt',
  'receiptComponent.jobReceipt': 'Job Receipt',
  'receiptComponent.eventName': 'Event Name',
  'receiptComponent.logoText': 'Pharmaceutical & BioScience Society',
  'receiptComponent.location': 'Location',
  'receiptComponent.eventType': 'Event Type',
  'receiptComponent.name': 'Name',
  'receiptComponent.email': 'Email',
  'receiptComponent.company': 'Company',
  'receiptComponent.department': 'Department',
  'receiptComponent.jobTitle': 'Job Title',
  'receiptComponent.vendor': 'Vendor',
  'receiptComponent.employer': 'Employer',
  'receiptComponent.position': 'Position',
  'receiptComponent.positionDesignation': 'Position / Designation',
  'receiptComponent.contactInfo': 'Contact Information',
  'receiptComponent.attachmentUrl': 'Attachment URL',
  'receiptComponent.adType': 'Ad Type',
  'receiptComponent.jobType': 'Job Type',
  'receiptComponent.months': 'Duration (months)',
  'receiptComponent.listingPeriod': 'Listing period',
  'receiptComponent.jobNotApprovedYet': 'Job is not approved yet',
  'receiptComponent.adNotApprovedYet': 'Ad is not approved yet',
  'receiptComponent.description': 'Description',
  'receiptComponent.requirement': 'Requirements',
  'receiptComponent.advertiserName': 'Advertiser Name',
  'receiptComponent.totalPrice': 'Total Price',
  'receiptComponent.transactionId': 'Transaction ID',
  'receiptComponent.refundedAmount': 'Refunded Amount',
  'receiptComponent.refundType': 'Refund Type',
  'receiptComponent.registrationOptions': 'Registration Options',
  'receiptComponent.foodOptions': 'Food Options',
  'receiptComponent.attendanceType': 'Attendance Type',
  'receiptComponent.totalCost': 'Paid amount',
  'receiptComponent.paymentDetails': 'Payment Details',
  'receiptComponent.price': 'Price',
  'receiptComponent.downloading': 'Downloading...',
  'receiptComponent.downloadReceipt': 'Download Receipt',
  'receiptComponent.localChapterName': 'Local Chapter Name',
  'receiptComponent.discount': 'Discount',
  'receiptComponent.processingFee': 'Processing Fee (2.9%)',
  'receiptComponent.processingFeeTooltip':
    'This processing fee is not refundable.',
  'receiptComponent.processingFeeNote':
    'Note: The processing fee is not refundable.',
  'receiptComponent.total': 'Paid amount',
  'receiptComponent.date': 'Date',
  'receiptComponent.paymentDate': 'Payment Date',
  'receiptComponent.cardLast4': 'Credit Card Number',
  'receiptComponent.status': 'Registration Status',

  //Add Attendee Component
  'addAttendeeComponent.table.title.name': 'Name',
  'addAttendeeComponent.table.title.email': 'Email',
  'addAttendeeComponent.table.title.option': 'Option',
  'addAttendeeComponent.table.title.company': 'Company/Affiliation',
  'addAttendeeComponent.table.title.price': 'Price',
  'addAttendeeComponent.table.title.attendanceType': 'Attendance Type',
  'addAttendeeComponent.table.title.action': 'Action',
  'addAttendeeComponent.confirmationAction.heading': 'Total amount to be paid',
  'addAttendeeComponent.confirmationAction.submitName': 'Continue',

  //Sponsorship Option Component
  'sponsorshipOptionComponent.heading': 'Sponsorship Options',
  'sponsorshipOptionComponent.alertMessage':
    'No sponsorship options available for this event.',
  'sponsorshipOptionComponent.goBackToAttendeeRegistration':
    'Go Back to Attendee Registration',
  'sponsorshipOptionComponent.sponsorPerksListing.heading': 'Sponsor Perks',
  'sponsorshipOptionComponent.sponsorPerksListing.description':
    'Get Details about sponsorship options, schedule & more...',
  'sponsorshipOptionComponent.sponsorPerksListing.contactUs': 'Contact us at',
  'sponsorshipOptionComponent.sponsorPerksListing.contactUs.link':
    'info@pbss.org',
  'sponsorshipOptionComponent.sponsorPerksListing.contactUs.description':
    'if you have a question or run into a problem with your registration.',

  //Sponsor Perks Component
  'sponsorPerksComponent.sponsorPerks.spot': 'spot(s) remaining',
  'sponsorPerksComponent.sponsorPerks.uploadLogo':
    'Upload Company/Sponsor Logo',

  //Sponsor Add Component
  'sponsorAddComponent.table.title.name': 'Name',
  'sponsorAddComponent.table.title.email': 'Email',
  'sponsorAddComponent.table.title.option': 'Option',
  'sponsorAddComponent.table.title.company': 'Company/Affiliation',
  'sponsorAddComponent.table.title.price': 'Price',
  'sponsorAddComponent.table.title.attendanceType': 'Attendance Type',
  'sponsorAddComponent.table.title.action': 'Action',
  'sponsorAddComponent.confirmationAction.heading': 'Total amount to be paid',
  'sponsorAddComponent.confirmationAction.submitName': 'Proceed to Confirm',
  'sponsorAddComponent.errorMessage': 'Please save the sponsor details first.',
  'sponsorAddComponent.fileFormatError':
    'Accepted file formats: PDF, JPG and PNG only',
  'sponsorAddComponent.fileSizeError': (size) =>
    `File must smaller than ${size}MB.`,
  'sponsorAddComponent.imageSizeError':
    'Image size must be greater than 200x200 pixels.',
  'sponsorAddComponent.contactUs': 'Contact us at',
  'sponsorAddComponent.contactUs.link': 'info@pbss.org',

  //Sponsor Detail Form
  'sponsorDetailForm.contactPersonFirstName': 'Contact Person First Name',
  'sponsorDetailForm.contactPersonLastName': 'Contact Person Last Name',
  'sponsorDetailForm.contactPersonEmail': 'Contact Person Email',
  'sponsorDetailForm.companyAffiliation': 'Company/Affiliation',
  'sponsorDetailForm.action': 'Action',

  //Editable Cell
  'editableCell.emailAlreadyExists':
    'already exists as attendee email address!',
  'editableCell.quantityExhausted':
    'Quantity Exhausted for this option(please make a new registration to join our waiting list).',
  'editableCell.limitExhausted': 'Limit Exhausted for this option.',
  'editableCell.waitingList':
    'This registration option is currently full. Please add it to your cart to join the waiting list and be notified when more spots become available.',
  'editableCell.inPersonFull':
    "In-Person is full. You'll be added to the waiting list.",
  'editableCell.workshopPresentationFull':
    'Workshop presentation seats are full.',
  'editableCell.pleaseFillOutFirstName': 'Please fill out first name',
  'editableCell.enterAttendeeFirstName': 'Enter attendee first name',
  'editableCell.pleaseFillOutLastName': 'Please fill out last name',
  'editableCell.enterAttendeeLastName': 'Enter attendee last name',
  'editableCell.inPerson': 'In-Person',
  'editableCell.webcast': 'Webcast',
  'editableCell.forNonLocalsOnly': 'for non\u2011locals only',
  'editableCell.pleaseEnterValidEmail': 'Please enter a valid email address',
  'editableCell.pleaseFillOut': (title) => `Please fill out ${title}`,
  'editableCell.confirm': (title) => `Confirm ${title}`,
  'editableCell.confirmAttendee': (title) => `Confirm attendee ${title}`,
  'editableCell.enter': (title) => `Enter ${title}`,
  'editableCell.enterAttendee': (title) => `Enter attendee ${title}`,
  'editableCell.pleaseSelectRegistrationOption':
    'Please select attendee registration option',
  'editableCell.pleaseSelectFoodOption': 'Please select attendee food option',
  'editableCell.selectAttendeeFoodOption': 'Select attendee food option',
  'editableCell.emailIdsMustMatch': 'Email IDs must match',
  'editableCell.firstName': 'First name',
  'editableCell.lastName': 'Last name',
  'editableCell.pleaseConfirm': (title) => `Please confirm ${title}`,
  'editableCell.selectAttendeeRegistrationOption':
    'Select attendee registration option',
  'editableCell.departmentDivision': 'Department/Division',
  'editableCell.jobTitleRole': 'Job Title/Role',
  'editableCell.enterCompanyAffiliation': 'Company/affiliation',
  'editableCell.enterAttendeeDepartmentDivision': 'Department/division',
  'editableCell.enterAttendeeJobTitleRole': 'Job title/role',

  //Sponsor Modal
  'sponsorModal.assetDetails': 'Asset Details',
  'sponsorModal.uploadFlyer': 'Upload Flyer',
  'sponsorModal.acceptsOnly':
    'Accepts only pdf/image files (png, jpg, jpeg, pdf)',
  'sponsorModal.maximumFileSize': (size) => `Maximum file size is ${size}MB.`,
  'sponsorModal.acceptsOnlyImage': 'Accepts only image files (png, jpg, jpeg).',
  'sponsorModal.uploadCompanyLogo': 'Upload Company/Sponsor Logo',
  'sponsorModal.uploadedLogos': 'Uploaded Logos',
  'sponsorModal.uploadedFlyer': 'Uploaded Flyer',
  'sponsorModal.back': 'Back',
  'sponsorModal.submit': 'Submit',

  //Event Common Table
  'eventCommonTable.name': 'Name',
  'eventCommonTable.email': 'Email',
  'eventCommonTable.lunch': 'Lunch',
  'eventCommonTable.company': 'Company/Affiliation',
  'eventCommonTable.price': 'Price',
  'eventCommonTable.action': 'Action',
  'eventCommonTable.deleteText': 'Delete',
  'eventCommonTable.editText': 'Edit',
  'eventCommonTable.meetingPresentation.title':
    'Attending Meeting Presentation',
  'eventCommonTable.meetingPresentation.price': (price) =>
    `Attending Meeting Presentation at $${price}?`,
  'eventCommonTable.dinner.title': 'Attending Dinner',
  'eventCommonTable.dinner.price': (price) => `Attending Dinner at $${price}?`,
  'eventCommonTable.company': 'Company/Affiliation',
  'eventCommonTable.price': 'Price',

  //Sponsor Editable Cell
  'sponsorEditableCell.emailAlreadyExists': (value) =>
    `${value} already exists as attendee email address!`,
  'sponsorEditableCell.pleaseEnterValidEmailAddress':
    'Please enter a valid email address',
  'sponsorEditableCell.pleaseConfirmAttendee': (title) =>
    `Please confirm attendee ${title}`,
  'sponsorEditableCell.enterAttendee': (title) => `Enter attendee ${title}`,
  'sponsorEditableCell.pleaseSelectAttendeeLunchOption':
    'Please select attendee lunch option',
  'sponsorEditableCell.selectAttendeeLunchOption':
    'Select attendee lunch option',
  'sponsorEditableCell.pleaseFillOut': (title) => `Please fill out ${title}`,
  'sponsorEditableCell.confirm': (title) => `Confirm ${title}`,
  'sponsorEditableCell.confirmAttendee': (title) => `Confirm attendee ${title}`,
  'sponsorEditableCell.enter': (title) => `Enter ${title}`,
  'sponsorEditableCell.enterAttendee': (title) => `Enter attendee ${title}`,
  'sponsorEditableCell.pleaseSelectRegistrationOption':
    'Please select attendee registration option',
  'sponsorEditableCell.pleaseSelectFoodOption':
    'Please select attendee food option',
  'sponsorEditableCell.pleaseFillOutFirstName': 'Please fill out first name',
  'sponsorEditableCell.enterAttendeeFirstName': 'Enter attendee first name',
  'sponsorEditableCell.pleaseFillOutLastName': 'Please fill out last name',
  'sponsorEditableCell.enterAttendeeLastName': 'Enter attendee last name',

  //Sponsor Cart
  'userEventSponsorComponent.uploadLogo.error':
    'Accepted file formats: JPG and PNG only',
  'userEventSponsorComponent.uploadLogo.error.size': (size) =>
    `File must smaller than ${size}MB.`,
  'userEventSponsorComponent.uploadBanner.error':
    'Accepted file formats: PDF, JPG and PNG only',
  'userEventSponsorComponent.uploadBanner.error.size': (size) =>
    `File must smaller than ${size}MB.`,
  'userEventSponsorComponent.uploadBanner.error.imageSize':
    'Image size must be greater than 200x200 pixels.',

  //Common Modal
  'commonModal.cancel': 'Cancel',

  //Payment Success
  'paymentSuccess.thankYou': `
    Thank you for your registration. You will receive a confirmation email shortly.
  `,
  'paymentSuccess.registrationCompleted': 'Registration Completed',
  'paymentSuccess.thankYou2': `
    Your payment has been processed successfully. Thank you for your purchase.
        You will receive a confirmation email shortly..
  `,
  'paymentSuccess.adsTitle': 'Payment received.',
  'paymentSuccess.adsSubTitle':
    'Your ad will be reviewed and approved by the admin shortly.',
  'paymentSuccess.jobsTitle': 'Information received.',
  'paymentSuccess.jobsSubTitle':
    'Your job ad will be reviewed and approved by the admin shortly.',
  'paymentSuccess.title': 'Payment Successful!',
  'paymentSuccess.backToHome': 'Back to home',
  'paymentSuccess.goToAds': 'Go to Ads',
  'paymentSuccess.goToJobs': 'Go to Jobs',
  'paymentSuccess.goToMyEvents': 'Go to My Events',
  'paymentSuccess.goToPaymentProcessing': 'Go to My Cart',

  //Payment Checkout Form
  'paymentCheckoutComponent.backToCart': 'Back to cart',
  'paymentCheckoutComponent.backToAddAttendees': 'Back to Add Attendees',
  'paymentCheckoutComponent.registrationSummary.heading':
    'Registration Summary',
  'paymentCheckoutComponent.registrationSummary.couponApplied':
    'Coupon applied',
  'paymentCheckoutComponent.registrationSummary.vendorReps':
    'Vendor Representatives',
  'paymentCheckoutComponent.registrationSummary.sponsorshipOption':
    'Sponsorship option',

  //Chapter Page
  'chapterPage.sponsorshipDetails.title': 'Sponsorship Details',
  'chapterPage.contactUs.title': 'Contact Us',
  'chapterPage.mission.title': 'Our Mission',
  'chapterPage.chapterHeading.title': 'Chapter Leadership Team',
  'chapterPage.chapterHeading.subtitle': 'Click on member name for their bio',

  'mainLayoutComponent.navbar.login': 'Login',
  'mainLayoutComponent.navbar.join': 'Join PBSS',
  'mainLayoutComponent.navbar.logout': 'Logout',

  //Register Component
  'userRegisterComponent.contactUs': 'Contact us at',
  'userRegisterComponent.contactUsMessage':
    'if you have a question or run into a problem with your registration.',
  'userRegisterComponent.firstName': 'First Name',
  'userRegisterComponent.lastName': 'Last Name',
  'userRegisterComponent.email': 'Email',
  'userRegisterComponent.confirmEmail': 'Confirm Email',
  'userRegisterComponent.addNote':
    'In order to avoid login issues due to job changes, we strongly encourage you to use a permanent personal email address instead of your work email.',
  'userRegisterComponent.password': 'Password',
  'userRegisterComponent.confirmPassword': 'Confirm Password',
  'userRegisterComponent.address': 'Address',
  'userRegisterComponent.addressLine1': 'Address Line 1',
  'userRegisterComponent.addressLine2': 'Address Line 2',
  'userRegisterComponent.cityTown': 'City/Town',
  'userRegisterComponent.stateProvinceRegion': 'State/Province/Region',
  'userRegisterComponent.zipPostalCode': 'Zip/Postal Code',
  'userRegisterComponent.country': 'Country',
  'userRegisterComponent.companyName': 'Company / Organization',
  'userRegisterComponent.companyName.placeholder':
    'Enter company / organization, or N/A',
  'userRegisterComponent.companyName.helpText':
    'If you are not currently affiliated with an organization or institution, please enter N/A.',
  'userRegisterComponent.contactNumber': '+19898989898',
  'userRegisterComponent.contactNumber.title': 'Contact Number',
  'userRegisterComponent.localChapter': 'Local Chapter',
  'userRegisterComponent.selectChapter.title':
    'Select a PBSS Chapter(s) to receive its announcements',
  'userRegisterComponent.selectChapter':
    'Select a PBSS Chapter(s) to receive its announcements',
  'userRegisterComponent.selectArea': 'Select Area(s) of Interest',
  'userRegisterComponent.addOtherInterests': 'Add Other Interests',
  'userRegisterComponent.enterAreas':
    'Enter areas of interest, separated by comma',
  'userRegisterComponent.vendorRepresentative': 'I am a Vendor Representative',
  'userRegisterComponent.iAcceptTermsAndConditions':
    'By continuing, you agree to our Terms of Service and the Japan Chapter Event Terms.',
  'userRegisterComponent.iAcceptTermsAndConditions.title1':
    'By continuing, you agree to our',
  'userRegisterComponent.iAcceptTermsAndConditions.title2': 'Terms of Service',
  'userRegisterComponent.iAcceptTermsAndConditions.title3':
    'and the Japan Chapter Event Terms.',
  'userRegisterComponent.captcha': 'Please click on the CAPTCHA above',
  'userRegisterComponent.register':
    'Agree to PBSS Terms of Service and Register',
  'userRegisterComponent.cancel': 'Cancel',
  'userRegisterComponent.jobTitle.label': 'Job Title',
  'userRegisterComponent.jobTitle.placeholder': 'Enter job title, or N/A',
  'userRegisterComponent.jobTitle.helpText':
    'If you do not currently have a job title, please enter N/A.',
  'userRegisterComponent.jobTitle.required': 'Please enter your job title',
  'userRegisterComponent.companyNameLabel': 'Company / Organization',
  'userRegistrationComponent.successMessage':
    'Your account has been successfully created.​',

  //Login Component
  'userLoginComponent.email': 'Email address',
  'userLoginComponent.password': 'Password',
  'userLoginComponent.password.validation': 'Please fill out password',
  'userLoginComponent.notAMember': 'Not a member?',
  'userLoginComponent.createAccount': 'Click here to create a free account',
  'userLoginComponent.forgotPassword': 'Forgot my password',
  'userLoginComponent.completeCaptcha': 'Complete CAPTCHA',
  'userLoginComponent.login': 'Login',

  //User Update Profile Component
  'userUpdateProfileComponent.update_profile_success':
    'Profile Updated Successfully',

  //Event Card
  'eventCard.registrationClosed': 'Registration is closed',
  'eventCard.details': 'Details',
  'eventCard.speakers': 'Speakers',
  'eventCard.organizers': 'Organizers',
  'eventCard.registrationFee': 'Registration Fee',
  'eventCard.location': 'Location',
  'eventCard.sponsors': 'Sponsors',
  'eventCard.exhibitors': 'Exhibitors (Vendors)',
  'eventCard.webcastForNonLocalAttendees': 'Webcast for non-local attendees',
  'eventCard.registerNow': 'Register Now',
  'eventCard.cta.registrationClosed': 'Registration Closed',
  'eventCard.sponsorshipAvailable': 'Sponsorship Available',
  'eventCard.registrationClosesOn': 'Registration Closes On',
  'eventCard.otherSponsorshipOpportunitiesOpen':
    'other sponsorship opportunities are open',
  'eventCard.sponsorshipOpportunitiesOpen': 'Sponsorship opportunities open',
  'eventCard.vendorShowExhibitorOpportunitiesOpen':
    'Vendor Show Exhibitor opportunities are open',
  'eventCard.sponsorshipAtCapacity': '—',
  'eventCard.vendorShowAtCapacity': '—',

  //Add Attendees Component
  'addAttendeesComponent.label.noFoodOption': 'No Food',
  'userAddAttendeeComponent.coupancodeinput.placeholder':
    'Enter promotional code',
  'userAddAttendeeComponent.eventSponsor.limitof': 'limit of',
  'userAddAttendeeComponent.eventComanTable.free': 'Free',
  'userAddAttendeeComponent.faq': 'FAQ',
  'userAddAttendeeComponent.eventRegistrationModel.n/a': 'N/A',

  //Stay Tuned Component
  'stayTunedComponent.title': 'Stay tuned for more information!',
  'stayTunedComponent.backHome': 'Back Home',

  //Other Partners Component
  'otherPartnersComponent.title': 'Partner Organizations of PBSS',

  //Career Mentorship Component
  'careerMentorshipComponent.title': 'Career Mentorship',

  //Jobs Component
  'userJobsComponent.alert.title': 'No Jobs Available',

  //Text Editor
  'textEditor.enter': 'Enter',
  'textEditor.here': 'here',
  'textEditor.yourDetails': 'your details',

  //Footer
  'footer.links.title': 'Links',
  'footer.events.title': 'Events',

  //Event Details Component
  'eventDetailsComponent.viewFlyer': 'View Flyer',
  'eventDetailsComponent.eventFlyerImages': 'Event Flyer Images',

  'adminActionsDropdownComponent.saveText': 'Save',
  'adminActionsDropdownComponent.cancelText': 'Cancel',
  'adminActionsDropdownComponent.copyText': 'Copy',
  'adminActionsDropdownComponent.deleteText': 'Delete',

  'adminActionsDropdownComponent.deleteConfirmTitle': (text) =>
    `Delete Confirmation ${text}`,
  'adminActionsDropdownComponent.deleteConfirmDescription':
    'Are you sure you want to delete?',
  'adminActionsDropdownComponent.deleteConfirmOkText': 'Yes',
  'adminActionsDropdownComponent.deleteConfirmCancelText': 'No',

  'adminActionsDropdownComponent.toolTipTitle': 'Attendee',
  'majorSponsorListing.title': 'Major Sponsors',

  'resetPassword.title': 'Reset Password',
  'resetPassword.successTitle': 'Success! Password reset email sent!',
  'resetPassword.successSubTitle':
    'A password reset email has been successfully sent to the email address associated with your account. Please check your inbox and follow the instructions to reset your password. If you do not receive the email within a few minutes, please check your spam folder. If you continue to experience issues, please contact our support team. Thank you for choosing our service.',
  'resetPassword.goToLogin': 'Go to Login',
  'resetPassword.resendEmail': 'Resend Email',
  'resetPassword.heading': 'Reset Your Password',
  'resetPassword.subheading': `Enter your email address below and we will email you the link for resetting the password.`,
  'resetPassword.email': 'Email Address',
  'resetPassword.submit': 'Send Reset Link',
  'resetPassword.emailRequired': 'Email should be a valid email address​',
  'resetPassword.emailLabel': 'Email Address',
  'resetPassword.forgotPassword': 'Did you forget your password?',
  'resetPassword.enterEmail':
    "Enter email address you're using for PBSS account below and we will send you a password reset link",
  'resetPassword.backToSignIn': 'Back to Sign In',
  'resetPassword.resetButtonText': 'Reset Password',
  waitingListAttendees: 'Waiting List Attendees',
  'waitingList.firstName': 'Full Name',
  'waitingList.memberName': 'Member Name',
  'waitingList.memberEmail': 'Member Email',
  'waitingList.email': 'Email',
  'waitingList.registrationType': 'Registration Type',
  'waitingList.registrationType.workshop': 'Workshop',
  'waitingList.optionType': 'Option Type',
  'waitingList.optionType.registration': 'Registration',
  'waitingList.optionType.sponsorship': 'Sponsorship',
  'waitingList.attendeeType': 'Attendee Type',
  'waitingList.attendeeType.regular': 'Regular',
  'waitingList.eventOption': 'Event Option',
  'waitingList.attendanceType': 'Attendance Type',
  'waitingList.attendanceType.inPerson': 'In person',
  'waitingList.attendanceType.webcast': 'Webcast',
  'waitingList.sponsorshipType': 'Sponsorship Type',
  'waitingList.date': 'Date',
  'waitingList.localChapter': 'Local Chapter',
  'waitingList.attendeeAdded': 'Attendee Added',
  'waitingList.attendeeAddedShort': 'Added',
  'waitingList.actions': 'Actions',
  'waitingList.moveToRegistration': 'Move to Event Registration',
  'waitingList.moveToRegistration.confirmTitle': 'Move to Event Registration',
  'waitingList.moveToRegistration.confirmDescription':
    'This will increase the event option capacity, create a To Be Paid registration for this attendee, and mark them as registered on the waiting list. Continue?',
  'waitingList.moveToRegistration.success':
    'Attendee moved to event registration successfully.',
  'waitingList.cancelled': 'Cancelled',
  'waitingList.cancelEntry': 'Cancel Entry',
  'waitingList.cancelEntry.confirmTitle': 'Cancel Waiting List Entry',
  'waitingList.cancelEntry.confirmDescription':
    'This will remove the attendee from the active waiting list. They will no longer see this entry on their account. Continue?',
  'waitingList.cancelEntry.success': 'Waiting list entry cancelled successfully.',
  'pbss.generalInformation.subtitle':
    'This is general information for PBSS International. For chapter specific information, contact the chapter.',

  //Register Form
  'userRegisterComponent.captcha.title': 'Complete Captcha',
  'userRegisterComponent.emailValidation':
    'Email should be a valid email address!',
  'userRegisterComponent.passwordValidation':
    'Password must be at least 8 characters long!',
  'userRegisterComponent.passwordSpaceValidation':
    'Password cannot contain spaces!',
  'userRegisterComponent.passwordEmptyValidation':
    'Password should not be empty!',
  'userRegisterComponent.firstNameValidation':
    'First name does not allow numbers and it should be less than 255 characters!',
  'userRegisterComponent.lastNameValidation':
    'Last name does not allow numbers and it should be less than 255 characters!',

  'userRegisterComponent.cityValidation':
    'City only allows alphabets and it should be less than 255 characters!',

  'userRegisterComponent.contactNumberValidation':
    "Please enter a valid phone number starting with '+', followed by the country code, with a minimum of 10 digits and a maximum of 13 digits.",

  'userRegisterComponent.address1Validation':
    'Address Line 1 cannot include space at the beginning and should be less than or equal to 255 characters!',

  'userRegisterComponent.address2Validation':
    'Address Line 2 cannot include space at the beginning and should be less than or equal to 255 characters!',

  'userRegisterComponent.zipCodeValidation':
    'Zip code cannot include space at the beginning and should be less than or equal to 255 characters!',

  'userRegisterComponent.zipCodeRequired': 'Please enter your zip/postal code',

  'userRegisterComponent.stateRequired':
    'Please select your state/province/region',

  'userRegisterComponent.companyNameValidation':
    'Company name should be less than 255 characters!',

  'userRegisterComponent.jobTitleValidation':
    'Job title cannot include space at the beginning and should be less than or equal to 255 characters!',

  'userAddAttendeeComponent.messageForWebcast.question':
    "Why is the webcast's self-paying rate higher than the in-person attendance's self-paying rate?",

  'userAddAttendeeComponent.messageForWebcast.answer1':
    'The self-paying in-person price is substantially subsidized by the sponsors and exhibitors, who are eager to meet attendees in-person for networking and business development purposes. Since webcasts do not have sponsors, we cannot offer the same low subsidized rate, though the self-paying fee is still discounted ~60% compared to the regular rate.',

  'userAddAttendeeComponent.messageForWebcast.answer2':
    "We've also found that since the webcasts attract attendees from other chapters, these attendees won't attend their local chapter's in-person events on the same topic. This in turn results in fewer in-person attendees, and thus fewer sponsors, ultimately increasing expenses for attendees and jeopardizing the long-term viability of the organization and the great services we provide to the community.",

  'userAddAttendeeComponent.messageForWebcast.answer3':
    'Being a non-profit organization, our resources are limited and we must dynamically manage our tight budgets and rising expenses. Please rest assured that we make every effort to minimize expenses and maximize value for everyone.',

  'userAddAttendeeComponent.messageForWebcast.answer4':
    'You have several options: 1) If you are not in the same metro area of the hosting chapter, we can still allow you to attend the webcast at the same rate as the in-person self-paying rate; 2) Wait to attend your local chapter’s event on this topic at a later point, which will still have the ~85% discount; 3) Attend the webcast now and receive a free pass for the corresponding future in-person event at your chapter.',

  // Vendor reps on a paid sponsorship (My Events)
  'sponsorshipReps.sponsor': 'Sponsor',
  'sponsorshipReps.contact': 'Contact',
  'sponsorshipReps.freeRepsUsed': 'Free vendor reps used',
  'sponsorshipReps.addReps': 'Add Vendor Show Attendance',
  'sponsorshipReps.editReps': 'Edit Vendor Show Attendance',
  'sponsorshipReps.editRep': 'Edit',
  'sponsorshipReps.actions': 'Actions',
  'sponsorshipReps.originalPurchase': 'Sponsorship purchase',
  'sponsorshipReps.addedReps': 'Added vendor show attendance',
  'sponsorshipReps.payment': 'Payment',
  'sponsorshipReps.changesClosed':
    'Sponsorship registration and vendor reps can be added or edited until 7 days before the event. For further changes, please contact the PBSS admin or email us at info@pbss.org.',
  'sponsorshipReps.limitReached':
    'All free vendor reps for this sponsorship have been used.',
  'sponsorshipReps.limitReachedAll':
    'All free vendor reps and sponsor perk attendance for this sponsorship have been used.',
  'sponsorshipReps.payEachSponsorship':
    'Vendor reps are waiting on more than one sponsorship. Open each sponsorship and pay for its reps separately.',
  'sponsorshipReps.addRepsTitle': 'Add Vendor Show Attendance',
  'sponsorshipReps.editRepTitle': 'Edit Vendor Show Attendance',
  'sponsorshipReps.remainingFreeReps': 'Free vendor reps remaining',
  'sponsorshipReps.addAnotherRep': 'Add another rep',
  'sponsorshipReps.remove': 'Remove',
  'sponsorshipReps.rep': 'Vendor rep',
  'sponsorshipReps.firstName': 'First Name',
  'sponsorshipReps.lastName': 'Last Name',
  'sponsorshipReps.email': 'Email',
  'sponsorshipReps.company': 'Company',
  'sponsorshipReps.department': 'Department',
  'sponsorshipReps.jobTitle': 'Job Title',
  'sponsorshipReps.food': 'Lunch',
  'sponsorshipReps.noFood': 'No Food',
  'sponsorshipReps.discountedLunch': 'discounted sponsor lunch',
  'sponsorshipReps.attendPresentation': 'Attend presentation',
  'sponsorshipReps.dinnerWithSpeakers': 'Dinner with the speakers',
  'sponsorshipReps.freeLunch': 'Free lunch',
  'sponsorshipReps.required': 'This field is required',
  'sponsorshipReps.invalidEmail': 'Please enter a valid email',
  'sponsorshipReps.continueToPayment': 'Continue',
  'sponsorshipReps.save': 'Save',
  'sponsorshipReps.cancel': 'Cancel',
  'sponsorshipReps.paymentNote':
    'New reps are added as a separate payment under this sponsorship. A confirmation email is sent to the new reps only.',
  'sponsorshipReps.cancelCascadeNote':
    'Refunding or cancelling the sponsorship also refunds or cancels all of its vendor reps.',
  'sponsorshipReps.completeRepPayment': 'Complete vendor rep payment',
  'addVendorReps.title': 'Add Vendor Show Attendance',
  'addVendorReps.backToMyEvents': 'Back to My Events',
  'addVendorReps.existingReps': 'Vendor reps on this sponsorship',
  'addVendorReps.newReps': 'Add new vendor reps',
  'addVendorReps.addRep': 'Add vendor rep',
  'addVendorReps.noReps': 'No vendor reps in this payment',
  'addVendorReps.totalToPay': 'Total to pay',
  'addVendorReps.proceedToPayment': 'Proceed to payment',
  'addVendorReps.removeConfirm': 'Remove this vendor rep?',
  'addVendorReps.yes': 'Yes',
  'addVendorReps.no': 'No',
};
